/**
 * How each map looks — generated by tools/build_palettes.ts, do not edit.
 *
 * Derived from each map's own screenshot, with hand-authored entries in
 * maps/cs/curated.json taking precedence. Re-run the tool after changing
 * either source.
 */
import type { MapLook } from './themes.ts';

export const LOOKS: Record<string, MapLook> = {
 "747": {
  "roles": {
   "cover": 34064,
   "exterior_wall": 7762564,
   "floor": 5327970,
   "glass": 1511985,
   "ramp": 9342361,
   "riser": 5262178,
   "roof": 2433838,
   "soft_panel": 34064,
   "stair": 9868448,
   "static_hard": 8881556
  },
  "sky": 1315362,
  "fog": 1249566,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2236459,
  "sunIntensity": 2,
  "hemiSky": 1710118,
  "hemiGround": 1315864,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2039586,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "campanile",
   "water_tank"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "helipad",
   "sawtooth",
   "drum"
  ],
  "accent": 42004
 },
 "abbey": {
  "roles": {
   "cover": 4757488,
   "exterior_wall": 12363675,
   "floor": 4803651,
   "glass": 13033467,
   "ramp": 13483959,
   "riser": 5329736,
   "roof": 3356206,
   "soft_panel": 6662902,
   "stair": 13418424,
   "static_hard": 13549496
  },
  "sky": 8235741,
  "fog": 6789328,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15725302,
  "sunIntensity": 2.6,
  "hemiSky": 12373731,
  "hemiGround": 3289902,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3419175,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "agency": {
  "roles": {
   "cover": 3695000,
   "exterior_wall": 6186349,
   "floor": 4605513,
   "glass": 8625608,
   "ramp": 7239295,
   "riser": 5329237,
   "roof": 4013632,
   "soft_panel": 4618686,
   "stair": 7568517,
   "static_hard": 6910586
  },
  "sky": 6256800,
  "fog": 5794957,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 11581377,
  "sunIntensity": 2.6,
  "hemiSky": 8819883,
  "hemiGround": 3882046,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1316118,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "airstrip": {
  "roles": {
   "cover": 11563529,
   "exterior_wall": 9802621,
   "floor": 12498333,
   "glass": 11183018,
   "ramp": 10921361,
   "riser": 13551542,
   "roof": 10458478,
   "soft_panel": 14717191,
   "stair": 11184278,
   "static_hard": 10592139
  },
  "sky": 8617347,
  "fog": 7762294,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12302779,
  "sunIntensity": 2.6,
  "hemiSky": 10262684,
  "hemiGround": 9800304,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2763043,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "ali": {
  "roles": {
   "cover": 6900763,
   "exterior_wall": 6906447,
   "floor": 10194036,
   "glass": 6314560,
   "ramp": 6380364,
   "riser": 11246982,
   "roof": 7496274,
   "soft_panel": 7952158,
   "stair": 6643535,
   "static_hard": 7629912
  },
  "sky": 4604726,
  "fog": 4078641,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6249812,
  "sunIntensity": 2,
  "hemiSky": 5328451,
  "hemiGround": 6971732,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1381393,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "alley1": {
  "roles": {
   "cover": 6717445,
   "exterior_wall": 7962424,
   "floor": 6381644,
   "glass": 987655,
   "ramp": 6780216,
   "riser": 6446667,
   "roof": 3026212,
   "soft_panel": 7374080,
   "stair": 7436597,
   "static_hard": 8883519
  },
  "sky": 658439,
  "fog": 592390,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 921356,
  "sunIntensity": 2,
  "hemiSky": 789769,
  "hemiGround": 1973529,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 592390,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.06
  },
  "daylight": false,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "alleyway": {
  "roles": {
   "cover": 12261136,
   "exterior_wall": 5004651,
   "floor": 4416619,
   "glass": 462866,
   "ramp": 4806500,
   "riser": 4221549,
   "roof": 2041906,
   "soft_panel": 15538190,
   "stair": 4938339,
   "static_hard": 5728629
  },
  "sky": 197894,
  "fog": 395530,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 460809,
  "sunIntensity": 2,
  "hemiSky": 395273,
  "hemiGround": 395273,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 460809,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.06
  },
  "daylight": false,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "ancient": {
  "roles": {
   "floor": 7239008,
   "roof": 4344378,
   "static_hard": 9146745,
   "exterior_wall": 7633507,
   "riser": 8225897,
   "stair": 8818034,
   "ramp": 8554862,
   "cover": 11569716,
   "soft_panel": 4156218,
   "glass": 11065536
  },
  "sky": 6257240,
  "fog": 5926994,
  "fogNear": 24,
  "fogFar": 130,
  "sun": 15135944,
  "sunIntensity": 2.6,
  "hemiSky": 12574888,
  "hemiGround": 3751983,
  "hemiIntensity": 2.6,
  "grid": {
   "line": 3093799,
   "alpha": 0.22,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0
  },
  "daylight": false,
  "look": "A Mayan temple swallowed by jungle. Mossy stone, deep green canopy, gold inlay.",
  "skyline": [
   "ziggurat",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466,
  "curated": true
 },
 "anubis": {
  "roles": {
   "floor": 13808759,
   "roof": 10124358,
   "static_hard": 13215849,
   "exterior_wall": 12097370,
   "riser": 14467209,
   "stair": 13676657,
   "ramp": 13413485,
   "cover": 2059146,
   "soft_panel": 13211180,
   "glass": 7323864
  },
  "sky": 8830168,
  "fog": 13941904,
  "fogNear": 46,
  "fogFar": 230,
  "sun": 16774352,
  "sunIntensity": 3.2,
  "hemiSky": 13494006,
  "hemiGround": 9072448,
  "hemiIntensity": 2.4,
  "grid": {
   "line": 6967847,
   "alpha": 0.15,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0
  },
  "daylight": true,
  "look": "An Egyptian temple on the Nile. Ochre sandstone, gold, painted blue, hard sun.",
  "skyline": [
   "obelisk",
   "ziggurat"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "chamfer"
  ],
  "accent": 13805111,
  "curated": true
 },
 "apollo": {
  "roles": {
   "cover": 16261,
   "exterior_wall": 10401244,
   "floor": 10657949,
   "glass": 12376052,
   "ramp": 11191001,
   "riser": 11842481,
   "roof": 7762287,
   "soft_panel": 16005,
   "stair": 11189721,
   "static_hard": 11452640
  },
  "sky": 8234191,
  "fog": 6919105,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15659508,
  "sunIntensity": 2.6,
  "hemiSky": 11912921,
  "hemiGround": 7499886,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2834519,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668
 },
 "arabstreets": {
  "roles": {
   "cover": 7818509,
   "exterior_wall": 6181435,
   "floor": 11306570,
   "glass": 13226469,
   "ramp": 6312251,
   "riser": 12362083,
   "roof": 6965806,
   "soft_panel": 9657614,
   "stair": 6707775,
   "static_hard": 6970947
  },
  "sky": 9477307,
  "fog": 8293291,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15658993,
  "sunIntensity": 2.6,
  "hemiSky": 12436176,
  "hemiGround": 6246197,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1644049,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "arcticbiolab": {
  "roles": {
   "cover": 2122825,
   "exterior_wall": 5005163,
   "floor": 4806251,
   "glass": 4349817,
   "ramp": 4807524,
   "riser": 5859460,
   "roof": 2897728,
   "soft_panel": 2456664,
   "stair": 4741990,
   "static_hard": 5663862
  },
  "sky": 3754326,
  "fog": 3490124,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6187121,
  "sunIntensity": 2,
  "hemiSky": 4872034,
  "hemiGround": 3027772,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 724238,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "assault": {
  "roles": {
   "floor": 5263951,
   "roof": 3421747,
   "static_hard": 6448479,
   "exterior_wall": 4935241,
   "riser": 5922135,
   "stair": 6185307,
   "ramp": 5922135,
   "cover": 9067038,
   "soft_panel": 6965792,
   "glass": 8033440
  },
  "sky": 1843752,
  "fog": 2238510,
  "fogNear": 16,
  "fogFar": 95,
  "sun": 16764802,
  "sunIntensity": 2,
  "hemiSky": 9085108,
  "hemiGround": 2500650,
  "hemiIntensity": 2.6,
  "grid": {
   "line": 1711130,
   "alpha": 0.26,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.14
  },
  "daylight": false,
  "look": "A warehouse at night. Sodium lamps, oily concrete, corrugated steel, deep shadow.",
  "skyline": [
   "silo",
   "chimney",
   "crane"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 12872224,
  "curated": true
 },
 "assembly": {
  "roles": {
   "cover": 545716,
   "exterior_wall": 12434620,
   "floor": 11709605,
   "glass": 11119275,
   "ramp": 12829121,
   "riser": 12960187,
   "roof": 9339514,
   "soft_panel": 420324,
   "stair": 12828864,
   "static_hard": 13158086
  },
  "sky": 8553348,
  "fog": 7698039,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12500670,
  "sunIntensity": 2.6,
  "hemiSky": 10263966,
  "hemiGround": 8946041,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3289392,
   "alpha": 0.2,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad"
  ],
  "accent": 24539
 },
 "austria": {
  "roles": {
   "cover": 2308962,
   "exterior_wall": 10334428,
   "floor": 4674929,
   "glass": 15527928,
   "ramp": 11187417,
   "riser": 5070465,
   "roof": 3357522,
   "soft_panel": 2640253,
   "stair": 11187673,
   "static_hard": 11450592
  },
  "sky": 11056082,
  "fog": 9609154,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15790580,
  "sunIntensity": 2.6,
  "hemiSky": 14475497,
  "hemiGround": 3488843,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2963803,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "autumn_harvest": {
  "roles": {
   "cover": 9729816,
   "exterior_wall": 9746918,
   "floor": 10521667,
   "glass": 11915764,
   "ramp": 10601187,
   "riser": 12231237,
   "roof": 7627056,
   "soft_panel": 12424731,
   "stair": 10600675,
   "static_hard": 11126245
  },
  "sky": 7774161,
  "fog": 6524867,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15330801,
  "sunIntensity": 2.6,
  "hemiSky": 11584217,
  "hemiGround": 6774072,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2309466,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "aztec": {
  "roles": {
   "floor": 7895658,
   "roof": 5000770,
   "static_hard": 9343104,
   "exterior_wall": 7829866,
   "riser": 8685173,
   "stair": 9079931,
   "ramp": 8816759,
   "cover": 4153392,
   "soft_panel": 5929532,
   "glass": 9095360
  },
  "sky": 7047784,
  "fog": 6455391,
  "fogNear": 24,
  "fogFar": 135,
  "sun": 15267528,
  "sunIntensity": 2.7,
  "hemiSky": 12772524,
  "hemiGround": 3818034,
  "hemiIntensity": 2.6,
  "grid": {
   "line": 3224875,
   "alpha": 0.22,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0
  },
  "daylight": true,
  "look": "A jungle ruin over running water. Wet grey stone, dense green, shafts of light.",
  "skyline": [
   "ziggurat",
   "obelisk"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 3836500,
  "curated": true
 },
 "aztec2": {
  "roles": {
   "cover": 9206591,
   "exterior_wall": 10921885,
   "floor": 9012333,
   "glass": 12895684,
   "ramp": 12105903,
   "riser": 10197379,
   "roof": 7629917,
   "soft_panel": 11639630,
   "stair": 12434869,
   "static_hard": 11776938
  },
  "sky": 9934743,
  "fog": 8947847,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 14408667,
  "sunIntensity": 2.6,
  "hemiSky": 11908533,
  "hemiGround": 7236445,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2434338,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "backalley": {
  "roles": {
   "cover": 8722944,
   "exterior_wall": 7626819,
   "floor": 6315085,
   "glass": 3089433,
   "ramp": 7035203,
   "riser": 6841171,
   "roof": 4341814,
   "soft_panel": 8722432,
   "stair": 6969667,
   "static_hard": 8415820
  },
  "sky": 2169878,
  "fog": 1906964,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2893860,
  "sunIntensity": 2,
  "hemiSky": 2498844,
  "hemiGround": 4144438,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 723464,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "baggage": {
  "roles": {
   "cover": 11636488,
   "exterior_wall": 9868426,
   "floor": 6317158,
   "glass": 7497298,
   "ramp": 11579303,
   "riser": 7041138,
   "roof": 4606025,
   "soft_panel": 14857733,
   "stair": 12105392,
   "static_hard": 11052958
  },
  "sky": 5524803,
  "fog": 4867645,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 7565160,
  "sunIntensity": 2,
  "hemiSky": 6380627,
  "hemiGround": 4474438,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2631461,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.02
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "tower",
   "chamfer"
  ],
  "accent": 14199808
 },
 "balkan_map": {
  "roles": {
   "cover": 6049065,
   "exterior_wall": 6647388,
   "floor": 4935233,
   "glass": 15987697,
   "ramp": 7897453,
   "riser": 5659723,
   "roof": 3685168,
   "soft_panel": 6574634,
   "stair": 8161137,
   "static_hard": 7502952
  },
  "sky": 12960702,
  "fog": 11710634,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15987442,
  "sunIntensity": 2.6,
  "hemiSky": 15329767,
  "hemiGround": 3487792,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1579287,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "bank": {
  "roles": {
   "cover": 6511905,
   "exterior_wall": 5592388,
   "floor": 12562076,
   "glass": 14935774,
   "ramp": 5855562,
   "riser": 13812658,
   "roof": 10848883,
   "soft_panel": 7630117,
   "stair": 6118734,
   "static_hard": 6250318
  },
  "sky": 11515047,
  "fog": 10396821,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15922162,
  "sunIntensity": 2.6,
  "hemiSky": 13751246,
  "hemiGround": 10786179,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1250065,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "basalt": {
  "roles": {
   "cover": 7812641,
   "exterior_wall": 13351598,
   "floor": 6976106,
   "glass": 13424867,
   "ramp": 13353656,
   "riser": 7896950,
   "roof": 5067342,
   "soft_panel": 9978407,
   "stair": 13353144,
   "static_hard": 13682110
  },
  "sky": 9742264,
  "fog": 8558249,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15724786,
  "sunIntensity": 2.6,
  "hemiSky": 12568527,
  "hemiGround": 4935499,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 5129018,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "bazaar": {
  "roles": {
   "cover": 6111271,
   "exterior_wall": 5786433,
   "floor": 13874312,
   "glass": 15922162,
   "ramp": 6247754,
   "riser": 14927521,
   "roof": 12954708,
   "soft_panel": 7096621,
   "stair": 6575949,
   "static_hard": 6509898
  },
  "sky": 12370367,
  "fog": 11054764,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15921906,
  "sunIntensity": 2.6,
  "hemiSky": 15001060,
  "hemiGround": 13152651,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1381137,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "biome": {
  "roles": {
   "cover": 6117934,
   "exterior_wall": 10592927,
   "floor": 5197896,
   "glass": 13030110,
   "ramp": 12632255,
   "riser": 5724752,
   "roof": 3815987,
   "soft_panel": 7696953,
   "stair": 12763841,
   "static_hard": 12040373
  },
  "sky": 9478835,
  "fog": 8360612,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15330028,
  "sunIntensity": 2.6,
  "hemiSky": 12239562,
  "hemiGround": 3553075,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2829098,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "black_gold": {
  "roles": {
   "cover": 11042054,
   "exterior_wall": 5000524,
   "floor": 9732156,
   "glass": 15331061,
   "ramp": 4606278,
   "riser": 11246399,
   "roof": 6967596,
   "soft_panel": 14195970,
   "stair": 4606278,
   "static_hard": 5593429
  },
  "sky": 10794444,
  "fog": 9413308,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856372,
  "sunIntensity": 2.6,
  "hemiSky": 14081251,
  "hemiGround": 6247731,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 723723,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "water_tank"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "gable",
   "barrel",
   "arcade"
  ],
  "accent": 13473280
 },
 "blacksite": {
  "roles": {
   "cover": 2773603,
   "exterior_wall": 9939630,
   "floor": 8099745,
   "glass": 15398139,
   "ramp": 12305864,
   "riser": 9350065,
   "roof": 5663351,
   "soft_panel": 3303549,
   "stair": 12306376,
   "static_hard": 11583170
  },
  "sky": 11784159,
  "fog": 10140881,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15791093,
  "sunIntensity": 2.6,
  "hemiSky": 15659765,
  "hemiGround": 5794159,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2567471,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "blagai": {
  "roles": {
   "cover": 4358599,
   "exterior_wall": 7040348,
   "floor": 4933955,
   "glass": 10205655,
   "ramp": 8421485,
   "riser": 5723983,
   "roof": 4341307,
   "soft_panel": 7513049,
   "stair": 8685170,
   "static_hard": 7961448
  },
  "sky": 7245487,
  "fog": 6324385,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 13160149,
  "sunIntensity": 2.6,
  "hemiSky": 10136508,
  "hemiGround": 4144699,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1447443,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "boyard": {
  "roles": {
   "cover": 8205853,
   "exterior_wall": 10193781,
   "floor": 6641222,
   "glass": 12240856,
   "ramp": 11510165,
   "riser": 7562316,
   "roof": 4733234,
   "soft_panel": 10437410,
   "stair": 11905951,
   "static_hard": 11115660
  },
  "sky": 9017517,
  "fog": 7899550,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 14606563,
  "sunIntensity": 2.6,
  "hemiSky": 11647170,
  "hemiGround": 4406324,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2630688,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "breach": {
  "roles": {
   "cover": 7616016,
   "exterior_wall": 8225939,
   "floor": 5594735,
   "glass": 13621496,
   "ramp": 9475492,
   "riser": 6780037,
   "roof": 4607066,
   "soft_panel": 7878156,
   "stair": 9870504,
   "static_hard": 9146783
  },
  "sky": 8952022,
  "fog": 7505352,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15725045,
  "sunIntensity": 2.6,
  "hemiSky": 12765665,
  "hemiGround": 4672597,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1908514,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "brewery": {
  "roles": {
   "cover": 8463363,
   "exterior_wall": 9141102,
   "floor": 8869185,
   "glass": 6905688,
   "ramp": 10457994,
   "riser": 10248773,
   "roof": 6371375,
   "soft_panel": 9840641,
   "stair": 10918802,
   "static_hard": 10194306
  },
  "sky": 5196102,
  "fog": 4604479,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 7236457,
  "sunIntensity": 2,
  "hemiSky": 6117461,
  "hemiGround": 5783348,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2367518,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "bridge": {
  "roles": {
   "cover": 6966305,
   "exterior_wall": 7233098,
   "floor": 6707271,
   "glass": 3350806,
   "ramp": 7036748,
   "riser": 6969412,
   "roof": 3156770,
   "soft_panel": 8871975,
   "stair": 7365200,
   "static_hard": 7957075
  },
  "sky": 2300437,
  "fog": 2037779,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2959140,
  "sunIntensity": 2,
  "hemiSky": 2629659,
  "hemiGround": 1907222,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1512721,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "bunker": {
  "roles": {
   "cover": 7345230,
   "exterior_wall": 7880798,
   "floor": 7551819,
   "glass": 4278929,
   "ramp": 7094618,
   "riser": 8208467,
   "roof": 3611426,
   "soft_panel": 7606610,
   "stair": 7225181,
   "static_hard": 8473451
  },
  "sky": 4014437,
  "fog": 3685465,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6843267,
  "sunIntensity": 2,
  "hemiSky": 5264498,
  "hemiGround": 3219236,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 722954,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.06
  },
  "daylight": false,
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668
 },
 "cache": {
  "roles": {
   "floor": 9408392,
   "roof": 6513502,
   "static_hard": 10855836,
   "exterior_wall": 9079426,
   "riser": 10197907,
   "stair": 9934735,
   "ramp": 9671563,
   "cover": 9065000,
   "soft_panel": 11035188,
   "glass": 11848648
  },
  "sky": 10135723,
  "fog": 9937830,
  "fogNear": 30,
  "fogFar": 160,
  "sun": 15397102,
  "sunIntensity": 2.4,
  "hemiSky": 12767442,
  "hemiGround": 5658191,
  "hemiIntensity": 2.8,
  "grid": {
   "line": 3947575,
   "alpha": 0.19,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.93,
   "metalness": 0.05
  },
  "daylight": true,
  "look": "A Chernobyl service yard. Grey slab, rust, weeds coming through the concrete.",
  "skyline": [
   "cooling_tower",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "drum",
   "barrel",
   "helipad"
  ],
  "accent": 13148202,
  "curated": true
 },
 "calavera": {
  "roles": {
   "cover": 8730368,
   "exterior_wall": 6904399,
   "floor": 7294014,
   "glass": 3880232,
   "ramp": 7101775,
   "riser": 7293247,
   "roof": 3812129,
   "soft_panel": 9452800,
   "stair": 7430228,
   "static_hard": 7758678
  },
  "sky": 2828321,
  "fog": 2499614,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3881012,
  "sunIntensity": 2,
  "hemiSky": 3288874,
  "hemiGround": 3483683,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1052429,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "campanile",
   "water_tank",
   "spire"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 12739642
 },
 "canal": {
  "roles": {
   "cover": 6115368,
   "exterior_wall": 8224624,
   "floor": 5723467,
   "glass": 15528440,
   "ramp": 9408898,
   "riser": 7236189,
   "roof": 4671038,
   "soft_panel": 6181159,
   "stair": 9737608,
   "static_hard": 9079676
  },
  "sky": 12175066,
  "fog": 10596810,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15790836,
  "sunIntensity": 2.6,
  "hemiSky": 15725045,
  "hemiGround": 4473661,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1907995,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "crane",
   "chimney"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "setback",
   "tower",
   "chamfer"
  ],
  "accent": 8612641
 },
 "canals": {
  "roles": {
   "floor": 10521202,
   "roof": 8014388,
   "static_hard": 12626056,
   "exterior_wall": 11047026,
   "riser": 11573368,
   "stair": 11836542,
   "ramp": 11507577,
   "cover": 4155994,
   "soft_panel": 10119740,
   "glass": 9422016
  },
  "sky": 11584716,
  "fog": 12101260,
  "fogNear": 32,
  "fogFar": 170,
  "sun": 16774370,
  "sunIntensity": 2.7,
  "hemiSky": 13623526,
  "hemiGround": 6575680,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 5588532,
   "alpha": 0.18,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.93,
   "metalness": 0
  },
  "daylight": true,
  "look": "Venetian waterways. Damp brick, green water, weathered plaster, soft light.",
  "skyline": [
   "campanile",
   "dome"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "curved",
   "chamfer"
  ],
  "accent": 12080684,
  "curated": true
 },
 "cascade": {
  "roles": {
   "cover": 11172407,
   "exterior_wall": 7563106,
   "floor": 5129793,
   "glass": 13225169,
   "ramp": 8747123,
   "riser": 6379344,
   "roof": 4340278,
   "soft_panel": 13276751,
   "stair": 9141880,
   "static_hard": 8418158
  },
  "sky": 10067107,
  "fog": 9014419,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15001062,
  "sunIntensity": 2.6,
  "hemiSky": 12303808,
  "hemiGround": 4077878,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1710103,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "castle": {
  "roles": {
   "cover": 11693114,
   "exterior_wall": 5989756,
   "floor": 4805988,
   "glass": 5796242,
   "ramp": 6912401,
   "riser": 4936807,
   "roof": 3160899,
   "soft_panel": 13404762,
   "stair": 7306134,
   "static_hard": 6648203
  },
  "sky": 4937833,
  "fog": 4542301,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 7963019,
  "sunIntensity": 2,
  "hemiSky": 6253176,
  "hemiGround": 3290686,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1448220,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.04
  },
  "daylight": false,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "chalice": {
  "roles": {
   "cover": 8469275,
   "exterior_wall": 10326411,
   "floor": 7564393,
   "glass": 9342107,
   "ramp": 11444895,
   "riser": 8945789,
   "roof": 5919826,
   "soft_panel": 10701087,
   "stair": 11708837,
   "static_hard": 11116186
  },
  "sky": 7236983,
  "fog": 6513258,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 10789799,
  "sunIntensity": 2.6,
  "hemiSky": 8816012,
  "hemiGround": 5722961,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2433569,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "chateau": {
  "roles": {
   "floor": 11052188,
   "roof": 5132887,
   "static_hard": 12762804,
   "exterior_wall": 11052186,
   "riser": 11841702,
   "stair": 12104874,
   "ramp": 11775909,
   "cover": 5917236,
   "soft_panel": 8022608,
   "glass": 12900580
  },
  "sky": 12372176,
  "fog": 11714246,
  "fogNear": 30,
  "fogFar": 165,
  "sun": 16185594,
  "sunIntensity": 2.5,
  "hemiSky": 13951208,
  "hemiGround": 6447194,
  "hemiIntensity": 2.8,
  "grid": {
   "line": 4473404,
   "alpha": 0.17,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0
  },
  "daylight": true,
  "look": "A French country house in winter. Pale stone, slate roofs, bare trees, flat light.",
  "skyline": [
   "spire",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 6057866,
  "curated": true
 },
 "chinatown": {
  "roles": {
   "cover": 8727040,
   "exterior_wall": 7822913,
   "floor": 10655099,
   "glass": 9127969,
   "ramp": 7164736,
   "riser": 11708813,
   "roof": 7825238,
   "soft_panel": 8727296,
   "stair": 7166273,
   "static_hard": 8546378
  },
  "sky": 6109992,
  "fog": 5322278,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 7428943,
  "sunIntensity": 2,
  "hemiSky": 6703417,
  "hemiGround": 7366744,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1380622,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.08
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "chlorine": {
  "roles": {
   "cover": 15228427,
   "exterior_wall": 6176571,
   "floor": 5454918,
   "glass": 10790347,
   "ramp": 6373693,
   "riser": 5324103,
   "roof": 3089193,
   "soft_panel": 16416565,
   "stair": 6767937,
   "static_hard": 6899780
  },
  "sky": 7960994,
  "fog": 6974356,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 13224401,
  "sunIntensity": 2.6,
  "hemiSky": 10461109,
  "hemiGround": 1643799,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1117452,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "city": {
  "roles": {
   "cover": 2123072,
   "exterior_wall": 5139028,
   "floor": 4026471,
   "glass": 598571,
   "ramp": 4548692,
   "riser": 4091748,
   "roof": 1914162,
   "soft_panel": 2253366,
   "stair": 4809812,
   "static_hard": 5666397
  },
  "sky": 727069,
  "fog": 726297,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 1515299,
  "sunIntensity": 2,
  "hemiSky": 1055519,
  "hemiGround": 1120793,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 461063,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "cityofsin": {
  "roles": {
   "cover": 10424320,
   "exterior_wall": 8682876,
   "floor": 7231558,
   "glass": 6508353,
   "ramp": 9801358,
   "riser": 8875862,
   "roof": 6178621,
   "soft_panel": 13112576,
   "stair": 10130579,
   "static_hard": 9472649
  },
  "sky": 4734518,
  "fog": 4208690,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6380374,
  "sunIntensity": 2,
  "hemiSky": 5458756,
  "hemiGround": 5786175,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1907740,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.08
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "climb": {
  "roles": {
   "cover": 2586075,
   "exterior_wall": 5196364,
   "floor": 9076573,
   "glass": 10863340,
   "ramp": 4867399,
   "riser": 10458736,
   "roof": 5261365,
   "soft_panel": 6068455,
   "stair": 5130058,
   "static_hard": 5985111
  },
  "sky": 7246279,
  "fog": 6128313,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 14278374,
  "sunIntensity": 2.6,
  "hemiSky": 10728911,
  "hemiGround": 4867640,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1381396,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 2261759
 },
 "coast": {
  "roles": {
   "cover": 5611007,
   "exterior_wall": 8702710,
   "floor": 5065282,
   "glass": 13755898,
   "ramp": 9682928,
   "riser": 5525832,
   "roof": 3487278,
   "soft_panel": 6071039,
   "stair": 9685488,
   "static_hard": 9949686
  },
  "sky": 8892635,
  "fog": 7446221,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15725301,
  "sunIntensity": 2.6,
  "hemiSky": 12899556,
  "hemiGround": 3355182,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1721453,
   "alpha": 0.2,
   "scale": 1.9
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "water_tank",
   "spire"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 12739642
 },
 "cobblestone": {
  "roles": {
   "floor": 9145734,
   "roof": 5921878,
   "static_hard": 10395801,
   "exterior_wall": 8816767,
   "riser": 9737871,
   "stair": 9540496,
   "ramp": 9277320,
   "cover": 5914920,
   "soft_panel": 4153392,
   "glass": 11585744
  },
  "sky": 10464694,
  "fog": 9938350,
  "fogNear": 30,
  "fogFar": 165,
  "sun": 15397108,
  "sunIntensity": 2.4,
  "hemiSky": 12899550,
  "hemiGround": 5329741,
  "hemiIntensity": 2.8,
  "grid": {
   "line": 3684917,
   "alpha": 0.21,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0
  },
  "daylight": true,
  "look": "An English castle in the rain. Wet grey stone, dark timber, green lawn.",
  "skyline": [
   "spire",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 7162412,
  "curated": true
 },
 "cobblestone_halloween": {
  "roles": {
   "cover": 9717263,
   "exterior_wall": 4151928,
   "floor": 4148846,
   "glass": 5204662,
   "ramp": 4346482,
   "riser": 3953266,
   "roof": 1908533,
   "soft_panel": 12409102,
   "stair": 4545399,
   "static_hard": 4744324
  },
  "sky": 4740992,
  "fog": 4477041,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 8620959,
  "sunIntensity": 2,
  "hemiSky": 6385039,
  "hemiGround": 1514275,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1053464,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "coldstorage": {
  "roles": {
   "cover": 7228183,
   "exterior_wall": 6970701,
   "floor": 6773319,
   "glass": 2564118,
   "ramp": 6641736,
   "riser": 6840390,
   "roof": 3353631,
   "soft_panel": 7293973,
   "stair": 6641481,
   "static_hard": 7825493
  },
  "sky": 1841427,
  "fog": 1644050,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2433823,
  "sunIntensity": 2,
  "hemiSky": 2104601,
  "hemiGround": 1381135,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 591879,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.02
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "compound": {
  "roles": {
   "cover": 7743503,
   "exterior_wall": 12761255,
   "floor": 6379067,
   "glass": 11707540,
   "ramp": 13353913,
   "riser": 7300416,
   "roof": 4601898,
   "soft_panel": 8727309,
   "stair": 13354424,
   "static_hard": 13683645
  },
  "sky": 9141872,
  "fog": 8089958,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12170930,
  "sunIntensity": 2.6,
  "hemiSky": 10393487,
  "hemiGround": 4209197,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3551530,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "conditionabillion": {
  "roles": {
   "cover": 11192466,
   "exterior_wall": 11849643,
   "floor": 11580328,
   "glass": 15661293,
   "ramp": 12441007,
   "riser": 12895679,
   "roof": 9671813,
   "soft_panel": 11061395,
   "stair": 12178863,
   "static_hard": 12572854
  },
  "sky": 13492936,
  "fog": 11915694,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856880,
  "sunIntensity": 2.6,
  "hemiSky": 15857136,
  "hemiGround": 10264725,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4150839,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "crane",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "barrel",
   "arcade"
  ],
  "accent": 12180891
 },
 "construction": {
  "roles": {
   "cover": 7483411,
   "exterior_wall": 6967374,
   "floor": 6377293,
   "glass": 3484203,
   "ramp": 7888730,
   "riser": 6311501,
   "roof": 3813422,
   "soft_panel": 7679504,
   "stair": 8216926,
   "static_hard": 7690839
  },
  "sky": 2630179,
  "fog": 2367263,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3617588,
  "sunIntensity": 2,
  "hemiSky": 3090730,
  "hemiGround": 3616558,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1314832,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "corruption": {
  "roles": {
   "cover": 5727265,
   "exterior_wall": 9143670,
   "floor": 6444619,
   "glass": 9079918,
   "ramp": 10526355,
   "riser": 6838605,
   "roof": 4340786,
   "soft_panel": 6385954,
   "stair": 10986650,
   "static_hard": 10196617
  },
  "sky": 6776921,
  "fog": 6053201,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 9408391,
  "sunIntensity": 2,
  "hemiSky": 7961197,
  "hemiGround": 4077619,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2368288,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668
 },
 "counter_terrorist_training": {
  "roles": {
   "cover": 3885371,
   "exterior_wall": 4869962,
   "floor": 6915446,
   "glass": 11056806,
   "ramp": 4606278,
   "riser": 7771522,
   "roof": 5005399,
   "soft_panel": 3951163,
   "stair": 4540997,
   "static_hard": 5462867
  },
  "sky": 8424831,
  "fog": 7569266,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12698816,
  "sunIntensity": 2.6,
  "hemiSky": 10331293,
  "hemiGround": 5069395,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 986895,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "water_tank",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad"
  ],
  "accent": 4480580
 },
 "counter_terrorist_training_center": {
  "roles": {
   "cover": 8552195,
   "exterior_wall": 6839887,
   "floor": 6251084,
   "glass": 5457973,
   "ramp": 6510924,
   "riser": 6250829,
   "roof": 2960932,
   "soft_panel": 8749568,
   "stair": 6905680,
   "static_hard": 7629400
  },
  "sky": 3946029,
  "fog": 3485993,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5328199,
  "sunIntensity": 2,
  "hemiSky": 4538424,
  "hemiGround": 2500129,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1052429,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.08
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "campanile"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "chamfer",
   "curved",
   "setback"
  ],
  "accent": 10788864
 },
 "county": {
  "roles": {
   "cover": 10510627,
   "exterior_wall": 5525064,
   "floor": 11703914,
   "glass": 15332604,
   "ramp": 6840153,
   "riser": 12627333,
   "roof": 8281154,
   "soft_panel": 13400616,
   "stair": 7234909,
   "static_hard": 6445908
  },
  "sky": 10274525,
  "fog": 8762831,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15725557,
  "sunIntensity": 2.6,
  "hemiSky": 14280428,
  "hemiGround": 7561800,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1644310,
   "alpha": 0.2,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "cranes": {
  "roles": {
   "cover": 11814450,
   "exterior_wall": 9342089,
   "floor": 5658710,
   "glass": 2763562,
   "ramp": 10987173,
   "riser": 5658710,
   "roof": 2697513,
   "soft_panel": 13722190,
   "stair": 11513517,
   "static_hard": 10591900
  },
  "sky": 2105633,
  "fog": 1908253,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3092527,
  "sunIntensity": 2,
  "hemiSky": 2566183,
  "hemiGround": 1776411,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2434340,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.04
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "crash": {
  "roles": {
   "cover": 7952140,
   "exterior_wall": 6839345,
   "floor": 12368543,
   "glass": 14933182,
   "ramp": 6773303,
   "riser": 13618613,
   "roof": 10589556,
   "soft_panel": 8149000,
   "stair": 7102777,
   "static_hard": 7628345
  },
  "sky": 12169352,
  "fog": 11182455,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15461094,
  "sunIntensity": 2.6,
  "hemiSky": 13420725,
  "hemiGround": 9868150,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1446925,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "crashsite": {
  "roles": {
   "cover": 8473901,
   "exterior_wall": 12298908,
   "floor": 6842469,
   "glass": 15986408,
   "ramp": 13418679,
   "riser": 7632496,
   "roof": 4934473,
   "soft_panel": 10772022,
   "stair": 13353401,
   "static_hard": 13484984
  },
  "sky": 12957864,
  "fog": 11904660,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15987441,
  "sunIntensity": 2.6,
  "hemiSky": 14736598,
  "hemiGround": 4737351,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3353639,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "crete": {
  "roles": {
   "cover": 3307483,
   "exterior_wall": 7559259,
   "floor": 4867397,
   "glass": 11192560,
   "ramp": 8874092,
   "riser": 5722192,
   "roof": 3946809,
   "soft_panel": 6921447,
   "stair": 9202800,
   "static_hard": 8479591
  },
  "sky": 7378892,
  "fog": 6260670,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 14738667,
  "sunIntensity": 2.6,
  "hemiSky": 11057875,
  "hemiGround": 3881016,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1643541,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "crane",
   "chimney"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "tower",
   "curved",
   "signboard"
  ],
  "accent": 2982911
 },
 "cruise": {
  "roles": {
   "cover": 2318270,
   "exterior_wall": 6847909,
   "floor": 5335690,
   "glass": 8761312,
   "ramp": 9215157,
   "riser": 5796765,
   "roof": 3887459,
   "soft_panel": 3767007,
   "stair": 9806523,
   "static_hard": 8425650
  },
  "sky": 5932728,
  "fog": 5208488,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12437201,
  "sunIntensity": 2.6,
  "hemiSky": 9216958,
  "hemiGround": 4148059,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1909290,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "water_tank",
   "spire"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 12739642
 },
 "cultivating_trouble": {
  "roles": {
   "cover": 2056293,
   "exterior_wall": 4679537,
   "floor": 5201246,
   "glass": 1055773,
   "ramp": 4351851,
   "riser": 5201248,
   "roof": 2436396,
   "soft_panel": 1925479,
   "stair": 4415851,
   "static_hard": 5074816
  },
  "sky": 922645,
  "fog": 856594,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 1514268,
  "sunIntensity": 2,
  "hemiSky": 1185560,
  "hemiGround": 2237991,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 461065,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "campanile",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "chamfer",
   "curved",
   "setback"
  ],
  "accent": 1149330
 },
 "dahab": {
  "roles": {
   "cover": 8338694,
   "exterior_wall": 10781013,
   "floor": 9137719,
   "glass": 14999527,
   "ramp": 11640184,
   "riser": 10580792,
   "roof": 6576423,
   "soft_panel": 8601089,
   "stair": 11968129,
   "static_hard": 11506027
  },
  "sky": 11642806,
  "fog": 10524069,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15921907,
  "sunIntensity": 2.6,
  "hemiSky": 13881301,
  "hemiGround": 5851694,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2630426,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "damage": {
  "roles": {
   "cover": 9981961,
   "exterior_wall": 7496261,
   "floor": 10584920,
   "glass": 9662266,
   "ramp": 7100481,
   "riser": 11705969,
   "roof": 7031865,
   "soft_panel": 12674056,
   "stair": 7101761,
   "static_hard": 8416844
  },
  "sky": 6705976,
  "fog": 5851957,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 8484196,
  "sunIntensity": 2,
  "hemiSky": 7496268,
  "hemiGround": 6443839,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1512464,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "chimney",
   "silo"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad"
  ],
  "accent": 12607232
 },
 "demolition_training": {
  "roles": {
   "cover": 26867,
   "exterior_wall": 6576724,
   "floor": 6574153,
   "glass": 396051,
   "ramp": 7366497,
   "riser": 6770247,
   "roof": 3286303,
   "soft_panel": 3246591,
   "stair": 7760996,
   "static_hard": 7300445
  },
  "sky": 329482,
  "fog": 329738,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 592652,
  "sunIntensity": 2,
  "hemiSky": 461067,
  "hemiGround": 591879,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1644310,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.04
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 1276159
 },
 "depot": {
  "roles": {
   "cover": 7097899,
   "exterior_wall": 12108224,
   "floor": 7893095,
   "glass": 15856370,
   "ramp": 12567748,
   "riser": 8879219,
   "roof": 5657419,
   "soft_panel": 8938036,
   "stair": 12567747,
   "static_hard": 12962249
  },
  "sky": 12041405,
  "fog": 10791595,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15921906,
  "sunIntensity": 2.6,
  "hemiSky": 14606560,
  "hemiGround": 5394250,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4409673,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "desert": {
  "roles": {
   "cover": 8737024,
   "exterior_wall": 4802641,
   "floor": 9676202,
   "glass": 14601422,
   "ramp": 4605003,
   "riser": 10992316,
   "roof": 6583681,
   "soft_panel": 8737536,
   "stair": 4604748,
   "static_hard": 5460316
  },
  "sky": 11638681,
  "fog": 10585736,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15724013,
  "sunIntensity": 2.6,
  "hemiSky": 13352896,
  "hemiGround": 6649209,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 789517,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "desertbunker": {
  "roles": {
   "cover": 8736000,
   "exterior_wall": 13287318,
   "floor": 10913583,
   "glass": 15070207,
   "ramp": 13945776,
   "riser": 12689710,
   "roof": 7886883,
   "soft_panel": 9392640,
   "stair": 13880752,
   "static_hard": 14274997
  },
  "sky": 10406899,
  "fog": 8435689,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15659767,
  "sunIntensity": 2.6,
  "hemiSky": 15331832,
  "hemiGround": 6903853,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3814435,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "destown": {
  "roles": {
   "cover": 8473092,
   "exterior_wall": 14135458,
   "floor": 8877142,
   "glass": 5453867,
   "ramp": 14201260,
   "riser": 10127197,
   "roof": 6442557,
   "soft_panel": 8669441,
   "stair": 14202284,
   "static_hard": 14466737
  },
  "sky": 3878182,
  "fog": 3418403,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5063744,
  "sunIntensity": 2,
  "hemiSky": 4405042,
  "hemiGround": 5918785,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 5124395,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.02
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "dizzy": {
  "roles": {
   "cover": 4936267,
   "exterior_wall": 10861781,
   "floor": 12498333,
   "glass": 13754600,
   "ramp": 11322584,
   "riser": 13551798,
   "roof": 10589304,
   "soft_panel": 6056030,
   "stair": 11322072,
   "static_hard": 11782107
  },
  "sky": 9875133,
  "fog": 8691374,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856628,
  "sunIntensity": 2.6,
  "hemiSky": 12832468,
  "hemiGround": 11841695,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2965322,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "docks": {
  "roles": {
   "cover": 3885633,
   "exterior_wall": 5661016,
   "floor": 3111039,
   "glass": 593524,
   "ramp": 5397590,
   "riser": 3111551,
   "roof": 1325886,
   "soft_panel": 3755073,
   "stair": 5332053,
   "static_hard": 6253925
  },
  "sky": 1382476,
  "fog": 1382466,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3421784,
  "sunIntensity": 2,
  "hemiSky": 2303313,
  "hemiGround": 462608,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 592393,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.04
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "dogtown": {
  "roles": {
   "cover": 9580297,
   "exterior_wall": 10652829,
   "floor": 8410191,
   "glass": 9791890,
   "ramp": 12299704,
   "riser": 9525590,
   "roof": 5980473,
   "soft_panel": 12269576,
   "stair": 12826561,
   "static_hard": 11903665
  },
  "sky": 7165547,
  "fog": 6377312,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 9734291,
  "sunIntensity": 2,
  "hemiSky": 8350845,
  "hemiGround": 5521212,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2827561,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "downed": {
  "roles": {
   "cover": 5928208,
   "exterior_wall": 9469021,
   "floor": 6188098,
   "glass": 7365174,
   "ramp": 10654831,
   "riser": 7568716,
   "roof": 4149041,
   "soft_panel": 6125580,
   "stair": 10916725,
   "static_hard": 10389865
  },
  "sky": 5130033,
  "fog": 4538157,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6709587,
  "sunIntensity": 2,
  "hemiSky": 5854016,
  "hemiGround": 4344116,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2170648,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668
 },
 "downtown": {
  "roles": {
   "cover": 11429740,
   "exterior_wall": 6250839,
   "floor": 5987155,
   "glass": 5329222,
   "ramp": 6053204,
   "riser": 5987409,
   "roof": 2828838,
   "soft_panel": 13144982,
   "stair": 6382425,
   "static_hard": 6908769
  },
  "sky": 4013367,
  "fog": 3552818,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5658194,
  "sunIntensity": 2,
  "hemiSky": 4737091,
  "hemiGround": 2697253,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 921358,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "dust": {
  "roles": {
   "floor": 14469538,
   "roof": 10521696,
   "static_hard": 13480579,
   "exterior_wall": 12361584,
   "riser": 14996142,
   "stair": 13941650,
   "ramp": 13678478,
   "cover": 10119994,
   "soft_panel": 12355651,
   "glass": 13625087
  },
  "sky": 9813726,
  "fog": 14536106,
  "fogNear": 46,
  "fogFar": 220,
  "sun": 16774616,
  "sunIntensity": 3.2,
  "hemiSky": 13820658,
  "hemiGround": 9337172,
  "hemiIntensity": 2.4,
  "grid": {
   "line": 7231285,
   "alpha": 0.13,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0
  },
  "daylight": true,
  "look": "The original. Smaller, sandier and even more washed out than its sequel.",
  "skyline": [
   "minaret",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable"
  ],
  "accent": 13208636,
  "curated": true
 },
 "dust3": {
  "roles": {
   "cover": 7619857,
   "exterior_wall": 10650193,
   "floor": 16765788,
   "glass": 15070463,
   "ramp": 11572850,
   "riser": 16770693,
   "roof": 16757530,
   "soft_panel": 7751182,
   "stair": 11968378,
   "static_hard": 11571812
  },
  "sky": 13101053,
  "fog": 10605558,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15594488,
  "sunIntensity": 2.6,
  "hemiSky": 15398139,
  "hemiGround": 15517543,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2629912,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "dust_ii": {
  "roles": {
   "floor": 14205850,
   "roof": 10257752,
   "static_hard": 13216892,
   "exterior_wall": 12098156,
   "riser": 14732714,
   "stair": 13678477,
   "ramp": 13480840,
   "cover": 10119994,
   "soft_panel": 12091967,
   "glass": 13625087
  },
  "sky": 9418968,
  "fog": 14272934,
  "fogNear": 48,
  "fogFar": 230,
  "sun": 16774100,
  "sunIntensity": 3.1,
  "hemiSky": 13623538,
  "hemiGround": 9074000,
  "hemiIntensity": 2.4,
  "grid": {
   "line": 7033907,
   "alpha": 0.14,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0
  },
  "daylight": true,
  "look": "Sandstone fort under a hard desert sun. Everything is warm; the shade is warm too.",
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636,
  "curated": true
 },
 "dust_ii_control": {
  "roles": {
   "cover": 10587225,
   "exterior_wall": 12831407,
   "floor": 5526602,
   "glass": 15659503,
   "ramp": 13093816,
   "riser": 6119251,
   "roof": 4013109,
   "soft_panel": 12232831,
   "stair": 13028280,
   "static_hard": 13291710
  },
  "sky": 11779765,
  "fog": 10529954,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15922162,
  "sunIntensity": 2.6,
  "hemiSky": 14409692,
  "hemiGround": 3815989,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 5132606,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "dust_ii_retro": {
  "roles": {
   "cover": 8205831,
   "exterior_wall": 14923671,
   "floor": 9595211,
   "glass": 15922162,
   "ramp": 14598822,
   "riser": 11039056,
   "roof": 6902326,
   "soft_panel": 8467460,
   "stair": 14598054,
   "static_hard": 15058089
  },
  "sky": 12566973,
  "fog": 11317161,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15921906,
  "sunIntensity": 2.6,
  "hemiSky": 15066853,
  "hemiGround": 6245179,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 5651492,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "edin": {
  "roles": {
   "cover": 7494716,
   "exterior_wall": 10459541,
   "floor": 5724257,
   "glass": 9668999,
   "ramp": 12302260,
   "riser": 6381933,
   "roof": 4079686,
   "soft_panel": 9466699,
   "stair": 12828863,
   "static_hard": 11775915
  },
  "sky": 7367272,
  "fog": 6643806,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 10460315,
  "sunIntensity": 2.6,
  "hemiSky": 8749183,
  "hemiGround": 4079171,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2762791,
   "alpha": 0.2,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "elysion": {
  "roles": {
   "cover": 5857062,
   "exterior_wall": 12566202,
   "floor": 11711145,
   "glass": 7039060,
   "ramp": 12895423,
   "riser": 12960958,
   "roof": 9147270,
   "soft_panel": 5922853,
   "stair": 12895167,
   "static_hard": 13224389
  },
  "sky": 5262659,
  "fog": 4670781,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 7302503,
  "sunIntensity": 2,
  "hemiSky": 6118227,
  "hemiGround": 11251111,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 5329485,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.04
  },
  "daylight": false,
  "skyline": [
   "chimney",
   "silo"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad"
  ],
  "accent": 8095261
 },
 "ember": {
  "roles": {
   "cover": 8721152,
   "exterior_wall": 11191504,
   "floor": 5979446,
   "glass": 15594487,
   "ramp": 11847632,
   "riser": 6767676,
   "roof": 4336423,
   "soft_panel": 9508352,
   "stair": 11847376,
   "static_hard": 11979480
  },
  "sky": 13819620,
  "fog": 12110291,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856628,
  "sunIntensity": 2.6,
  "hemiSky": 15791093,
  "hemiGround": 3943722,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4085088,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "empire": {
  "roles": {
   "cover": 7684379,
   "exterior_wall": 8948361,
   "floor": 12432286,
   "glass": 14675443,
   "ramp": 10132635,
   "riser": 13484983,
   "roof": 10391918,
   "soft_panel": 9719840,
   "stair": 10461600,
   "static_hard": 9803670
  },
  "sky": 10271946,
  "fog": 8956858,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856628,
  "sunIntensity": 2.6,
  "hemiSky": 13556447,
  "hemiGround": 9734001,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2500390,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "engage": {
  "roles": {
   "cover": 2325448,
   "exterior_wall": 11845318,
   "floor": 9478307,
   "glass": 11845318,
   "ramp": 12240073,
   "riser": 10924470,
   "roof": 7440263,
   "soft_panel": 4364515,
   "stair": 12240073,
   "static_hard": 12634318
  },
  "sky": 8884891,
  "fog": 7963789,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 13751253,
  "sunIntensity": 2.6,
  "hemiSky": 11120564,
  "hemiGround": 7437696,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2567472,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "crane",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "tower",
   "chamfer"
  ],
  "accent": 757247
 },
 "estate": {
  "roles": {
   "cover": 8743424,
   "exterior_wall": 15118740,
   "floor": 5718839,
   "glass": 16570805,
   "ramp": 14923937,
   "riser": 5849397,
   "roof": 3352607,
   "soft_panel": 8743424,
   "stair": 14923425,
   "static_hard": 15057321
  },
  "sky": 14526575,
  "fog": 13736027,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 16118253,
  "sunIntensity": 2.6,
  "hemiSky": 14731440,
  "hemiGround": 2761246,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 5715489,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "extraction": {
  "roles": {
   "cover": 2374240,
   "exterior_wall": 5065805,
   "floor": 7236717,
   "glass": 12897489,
   "ramp": 4736840,
   "riser": 8157306,
   "roof": 5197134,
   "soft_panel": 2308449,
   "stair": 4671303,
   "static_hard": 5789272
  },
  "sky": 9674660,
  "fog": 8687509,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 14803683,
  "sunIntensity": 2.6,
  "hemiSky": 12041407,
  "hemiGround": 5065548,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 789516,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668
 },
 "facade": {
  "roles": {
   "cover": 1388144,
   "exterior_wall": 5990266,
   "floor": 4671303,
   "glass": 15070975,
   "ramp": 7371407,
   "riser": 4671303,
   "roof": 2697513,
   "soft_panel": 1191282,
   "stair": 7766676,
   "static_hard": 6911369
  },
  "sky": 11065329,
  "fog": 9029095,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15660022,
  "sunIntensity": 2.6,
  "hemiSky": 15529209,
  "hemiGround": 2105376,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1645343,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "water_tank"
  ],
  "facade": "industrial",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 11684
 },
 "facility": {
  "roles": {
   "cover": 9275174,
   "exterior_wall": 5791582,
   "floor": 5528151,
   "glass": 4210495,
   "ramp": 5462615,
   "riser": 5857373,
   "roof": 3092784,
   "soft_panel": 11774509,
   "stair": 5462868,
   "static_hard": 6384485
  },
  "sky": 3223856,
  "fog": 2894892,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 4671302,
  "sunIntensity": 2,
  "hemiSky": 3881530,
  "hemiGround": 3026991,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 460808,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.04
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "fang": {
  "roles": {
   "cover": 3753803,
   "exterior_wall": 5790560,
   "floor": 5136223,
   "glass": 1316155,
   "ramp": 5396315,
   "riser": 5005666,
   "roof": 2436397,
   "soft_panel": 3754059,
   "stair": 5396315,
   "static_hard": 6383467
  },
  "sky": 1316137,
  "fog": 1250340,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2434611,
  "sunIntensity": 2,
  "hemiSky": 1842477,
  "hemiGround": 1119252,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 789773,
   "alpha": 0.2,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "chimney"
  ],
  "facade": "industrial",
  "roofs": "pitched",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad"
  ],
  "accent": 4283234
 },
 "fastline": {
  "roles": {
   "cover": 8745984,
   "exterior_wall": 5525829,
   "floor": 5197120,
   "glass": 10066309,
   "ramp": 6841685,
   "riser": 5131073,
   "roof": 3223593,
   "soft_panel": 8745728,
   "stair": 7170649,
   "static_hard": 6447184
  },
  "sky": 7697512,
  "fog": 6842462,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 10658461,
  "sunIntensity": 2.6,
  "hemiSky": 9013631,
  "hemiGround": 3091753,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1052686,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "favela": {
  "roles": {
   "cover": 7691535,
   "exterior_wall": 7300935,
   "floor": 5918517,
   "glass": 15726068,
   "ramp": 8746325,
   "riser": 6116918,
   "roof": 4141606,
   "soft_panel": 7888140,
   "stair": 9142361,
   "static_hard": 8287570
  },
  "sky": 11848392,
  "fog": 10467510,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856627,
  "sunIntensity": 2.6,
  "hemiSky": 14870760,
  "hemiGround": 3814696,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1578257,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "water_tank",
   "spire"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 12739642
 },
 "foption": {
  "roles": {
   "cover": 2393344,
   "exterior_wall": 5397349,
   "floor": 6115415,
   "glass": 1315345,
   "ramp": 5133919,
   "riser": 6311508,
   "roof": 2828073,
   "soft_panel": 2393344,
   "stair": 5133664,
   "static_hard": 6055280
  },
  "sky": 986637,
  "fog": 855308,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 1381396,
  "sunIntensity": 2,
  "hemiSky": 1184016,
  "hemiGround": 1446677,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 657931,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.02
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "forest": {
  "roles": {
   "cover": 2655488,
   "exterior_wall": 6708306,
   "floor": 6443851,
   "glass": 1321483,
   "ramp": 7891297,
   "riser": 6509898,
   "roof": 4141872,
   "soft_panel": 2589952,
   "stair": 8286308,
   "static_hard": 7497564
  },
  "sky": 1121548,
  "fog": 1054988,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 1778456,
  "sunIntensity": 2,
  "hemiSky": 1449745,
  "hemiGround": 3879729,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1315345,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "frantic": {
  "roles": {
   "cover": 947985,
   "exterior_wall": 5658977,
   "floor": 6775908,
   "glass": 2566958,
   "ramp": 5527386,
   "riser": 7565424,
   "roof": 4868168,
   "soft_panel": 953361,
   "stair": 5461082,
   "static_hard": 6382955
  },
  "sky": 2040098,
  "fog": 1842719,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3092528,
  "sunIntensity": 2,
  "hemiSky": 2500648,
  "hemiGround": 4736582,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 855310,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "barrel",
   "arcade"
  ],
  "accent": 41989
 },
 "frostbite": {
  "roles": {
   "cover": 5475275,
   "exterior_wall": 10730710,
   "floor": 9414348,
   "glass": 11388899,
   "ramp": 11191001,
   "riser": 11321303,
   "roof": 6392248,
   "soft_panel": 8432347,
   "stair": 11190745,
   "static_hard": 11650780
  },
  "sky": 7903420,
  "fog": 6785454,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 14409700,
  "sunIntensity": 2.6,
  "hemiSky": 11057353,
  "hemiGround": 9676225,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2767435,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "genoserv": {
  "roles": {
   "cover": 8619264,
   "exterior_wall": 14141858,
   "floor": 10526851,
   "glass": 16512490,
   "ramp": 14206124,
   "riser": 11514261,
   "roof": 7828058,
   "soft_panel": 8684800,
   "stair": 14207148,
   "static_hard": 14473393
  },
  "sky": 14602415,
  "fog": 13614998,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 16118768,
  "sunIntensity": 2.6,
  "hemiSky": 15987178,
  "hemiGround": 7368540,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4931625,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "golden": {
  "roles": {
   "cover": 7230999,
   "exterior_wall": 10726583,
   "floor": 7368052,
   "glass": 6324902,
   "ramp": 12370632,
   "riser": 8288642,
   "roof": 5328723,
   "soft_panel": 7953944,
   "stair": 12370632,
   "static_hard": 12502219
  },
  "sky": 5399672,
  "fog": 4938346,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 9015964,
  "sunIntensity": 2,
  "hemiSky": 6912137,
  "hemiGround": 5197136,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2764082,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "grail": {
  "roles": {
   "cover": 810443,
   "exterior_wall": 6578538,
   "floor": 13344144,
   "glass": 14409703,
   "ramp": 7763326,
   "riser": 14202028,
   "roof": 11634791,
   "soft_panel": 1472246,
   "stair": 8157828,
   "static_hard": 7303033
  },
  "sky": 10660024,
  "fog": 9410216,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856371,
  "sunIntensity": 2.6,
  "hemiSky": 13356756,
  "hemiGround": 12493462,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1710620,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "grind": {
  "roles": {
   "cover": 12152369,
   "exterior_wall": 10861781,
   "floor": 13351567,
   "glass": 12243167,
   "ramp": 11322584,
   "riser": 14078381,
   "roof": 11965538,
   "soft_panel": 13929041,
   "stair": 11322072,
   "static_hard": 11782107
  },
  "sky": 8823221,
  "fog": 7770534,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 14869991,
  "sunIntensity": 2.6,
  "hemiSky": 11714504,
  "hemiGround": 12628883,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3162703,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "guard": {
  "roles": {
   "cover": 7802382,
   "exterior_wall": 10650993,
   "floor": 7826274,
   "glass": 9006668,
   "ramp": 11838868,
   "riser": 8877420,
   "roof": 5656647,
   "soft_panel": 8523277,
   "stair": 12298653,
   "static_hard": 11573641
  },
  "sky": 6443843,
  "fog": 5720893,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 8484973,
  "sunIntensity": 2,
  "hemiSky": 7365718,
  "hemiGround": 5327687,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2762015,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "gwalior": {
  "roles": {
   "cover": 6957339,
   "exterior_wall": 6111292,
   "floor": 9461330,
   "glass": 16118511,
   "ramp": 5717559,
   "riser": 10972515,
   "roof": 5585711,
   "soft_panel": 8597534,
   "stair": 5782584,
   "static_hard": 6965315
  },
  "sky": 13879746,
  "fog": 12694700,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15987441,
  "sunIntensity": 2.6,
  "hemiSky": 16052977,
  "hemiGround": 5060659,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1511696,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "hangar": {
  "roles": {
   "cover": 5781832,
   "exterior_wall": 12955594,
   "floor": 11904687,
   "glass": 15071487,
   "ramp": 13088971,
   "riser": 13155267,
   "roof": 9401737,
   "soft_panel": 7292506,
   "stair": 13154507,
   "static_hard": 13418192
  },
  "sky": 14742779,
  "fog": 12182770,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15660279,
  "sunIntensity": 2.6,
  "hemiSky": 15464185,
  "hemiGround": 8877697,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4010305,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "hankagai_bomb_defusal_map": {
  "roles": {
   "cover": 8735232,
   "exterior_wall": 9275471,
   "floor": 8218417,
   "glass": 3618080,
   "ramp": 10786140,
   "riser": 8746291,
   "roof": 6307877,
   "soft_panel": 8735488,
   "stair": 11051362,
   "static_hard": 10393432
  },
  "sky": 2565659,
  "fog": 2302489,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3420972,
  "sunIntensity": 2,
  "hemiSky": 2960419,
  "hemiGround": 5589036,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1907475,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "havana": {
  "roles": {
   "floor": 11839636,
   "roof": 9071176,
   "static_hard": 14207150,
   "exterior_wall": 12101260,
   "riser": 12891292,
   "stair": 13286306,
   "ramp": 12759704,
   "cover": 4160128,
   "soft_panel": 12872274,
   "glass": 10473688
  },
  "sky": 10471644,
  "fog": 13022876,
  "fogNear": 38,
  "fogFar": 190,
  "sun": 16773846,
  "sunIntensity": 3,
  "hemiSky": 13690096,
  "hemiGround": 7234128,
  "hemiIntensity": 2.4,
  "grid": {
   "line": 6181440,
   "alpha": 0.16,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.93,
   "metalness": 0
  },
  "daylight": true,
  "look": "Faded Caribbean colour. Peeling pastel plaster, sun-bleached, deep shade.",
  "skyline": [
   "campanile",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "curved",
   "chamfer"
  ],
  "accent": 4169896,
  "curated": true
 },
 "hideout": {
  "roles": {
   "cover": 8724480,
   "exterior_wall": 6306109,
   "floor": 8221544,
   "glass": 14798540,
   "ramp": 5716024,
   "riser": 9207156,
   "roof": 5854540,
   "soft_panel": 8724480,
   "stair": 5716027,
   "static_hard": 7029575
  },
  "sky": 11901077,
  "fog": 10913667,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15855342,
  "sunIntensity": 2.6,
  "hemiSky": 13484223,
  "hemiGround": 5591115,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 788488,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "highrise": {
  "roles": {
   "cover": 99094,
   "exterior_wall": 5918314,
   "floor": 5723990,
   "glass": 1707821,
   "ramp": 5916519,
   "riser": 6184540,
   "roof": 2697512,
   "soft_panel": 34070,
   "stair": 5851237,
   "static_hard": 6902649
  },
  "sky": 1380127,
  "fog": 1249051,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2104615,
  "sunIntensity": 2,
  "hemiSky": 1709346,
  "hemiGround": 2500133,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 657419,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "hive": {
  "roles": {
   "cover": 8740096,
   "exterior_wall": 6314583,
   "floor": 6839109,
   "glass": 2039585,
   "ramp": 5920083,
   "riser": 7496263,
   "roof": 4800303,
   "soft_panel": 10054656,
   "stair": 5855060,
   "static_hard": 7038049
  },
  "sky": 1579033,
  "fog": 1381910,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2302756,
  "sunIntensity": 2,
  "hemiSky": 1907998,
  "hemiGround": 4406321,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 526344,
   "alpha": 0.2,
   "scale": 1.9
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.06
  },
  "daylight": false,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "hostage_rescue_training": {
  "roles": {
   "cover": 15263015,
   "exterior_wall": 6052955,
   "floor": 6575434,
   "glass": 987153,
   "ramp": 5855575,
   "riser": 6576201,
   "roof": 3024932,
   "soft_panel": 15920993,
   "stair": 6118747,
   "static_hard": 6711141
  },
  "sky": 789517,
  "fog": 723724,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 1184274,
  "sunIntensity": 2,
  "hemiSky": 986895,
  "hemiGround": 1183759,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1315859,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 16776239
 },
 "inferno": {
  "roles": {
   "floor": 10322792,
   "roof": 9257766,
   "static_hard": 12819053,
   "exterior_wall": 11568983,
   "riser": 11439979,
   "stair": 12096607,
   "ramp": 11242083,
   "cover": 8215098,
   "soft_panel": 9398853,
   "glass": 12115176
  },
  "sky": 7315140,
  "fog": 12165508,
  "fogNear": 40,
  "fogFar": 190,
  "sun": 16773848,
  "sunIntensity": 3,
  "hemiSky": 13624048,
  "hemiGround": 7033916,
  "hemiIntensity": 2.4,
  "grid": {
   "line": 6179892,
   "alpha": 0.16,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0
  },
  "daylight": true,
  "look": "An Italian village at midday. Cream stucco, red tile roofs, cobbles, dark green shutters.",
  "skyline": [
   "campanile",
   "chimney",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 10239780,
  "curated": true
 },
 "insertion": {
  "roles": {
   "cover": 7216151,
   "exterior_wall": 7624535,
   "floor": 4867397,
   "glass": 16052466,
   "ramp": 8939367,
   "riser": 5722192,
   "roof": 3946296,
   "soft_panel": 8724250,
   "stair": 9333354,
   "static_hard": 8544866
  },
  "sky": 12958143,
  "fog": 11773356,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15987442,
  "sunIntensity": 2.6,
  "hemiSky": 15197413,
  "hemiGround": 3749430,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1643540,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668
 },
 "insertion_ii": {
  "roles": {
   "cover": 7573190,
   "exterior_wall": 7699072,
   "floor": 5592148,
   "glass": 15659510,
   "ramp": 8883346,
   "riser": 6973544,
   "roof": 5131597,
   "soft_panel": 9019602,
   "stair": 9277847,
   "static_hard": 8554381
  },
  "sky": 11449800,
  "fog": 10068408,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856371,
  "sunIntensity": 2.6,
  "hemiSky": 14475237,
  "hemiGround": 5000011,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1645083,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668
 },
 "iraq": {
  "roles": {
   "cover": 680059,
   "exterior_wall": 4090490,
   "floor": 6654578,
   "glass": 3954,
   "ramp": 4088943,
   "riser": 7445121,
   "roof": 4744017,
   "soft_panel": 483710,
   "stair": 4154222,
   "static_hard": 4682885
  },
  "sky": 922954,
  "fog": 988480,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2896212,
  "sunIntensity": 2,
  "hemiSky": 1778254,
  "hemiGround": 4873553,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 790803,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "iris": {
  "roles": {
   "cover": 8205064,
   "exterior_wall": 7362104,
   "floor": 10787461,
   "glass": 13622767,
   "ramp": 8414279,
   "riser": 11906712,
   "roof": 8023644,
   "soft_panel": 9385989,
   "stair": 8809291,
   "static_hard": 8217153
  },
  "sky": 9414856,
  "fog": 8099769,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15790836,
  "sunIntensity": 2.6,
  "hemiSky": 12766425,
  "hemiGround": 7564381,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1775121,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "italy": {
  "roles": {
   "floor": 11573368,
   "roof": 10242604,
   "static_hard": 14468772,
   "exterior_wall": 12889226,
   "riser": 13153426,
   "stair": 13811356,
   "ramp": 13482391,
   "cover": 8014374,
   "soft_panel": 12077103,
   "glass": 12377320
  },
  "sky": 11061470,
  "fog": 13482394,
  "fogNear": 38,
  "fogFar": 185,
  "sun": 16773327,
  "sunIntensity": 3,
  "hemiSky": 13952240,
  "hemiGround": 7890250,
  "hemiIntensity": 2.4,
  "grid": {
   "line": 6376499,
   "alpha": 0.16,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.93,
   "metalness": 0
  },
  "daylight": true,
  "look": "A Tuscan market street. Terracotta, cream plaster, striped awnings, warm light.",
  "skyline": [
   "campanile",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028010,
  "curated": true
 },
 "jail": {
  "roles": {
   "cover": 820480,
   "exterior_wall": 6511701,
   "floor": 6837317,
   "glass": 1580561,
   "ramp": 6051666,
   "riser": 6902597,
   "roof": 3222049,
   "soft_panel": 754944,
   "stair": 6444619,
   "static_hard": 7235166
  },
  "sky": 1185039,
  "fog": 1118990,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 1711128,
  "sunIntensity": 2,
  "hemiSky": 1447955,
  "hemiGround": 1512465,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 526343,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.02
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "jeepathon2k": {
  "roles": {
   "cover": 8214026,
   "exterior_wall": 5330499,
   "floor": 9207375,
   "glass": 15132159,
   "ramp": 5067069,
   "riser": 10853727,
   "roof": 5325102,
   "soft_panel": 10447881,
   "stair": 5001533,
   "static_hard": 6054730
  },
  "sky": 12105982,
  "fog": 9671415,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15592952,
  "sunIntensity": 2.6,
  "hemiSky": 15395579,
  "hemiGround": 4867121,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1316113,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "gable",
   "barrel",
   "arcade"
  ],
  "accent": 10906880
 },
 "jungle": {
  "roles": {
   "cover": 7554580,
   "exterior_wall": 8028060,
   "floor": 4608103,
   "glass": 6121113,
   "ramp": 10198449,
   "riser": 4608359,
   "roof": 2106929,
   "soft_panel": 9590551,
   "stair": 10725560,
   "static_hard": 9475500
  },
  "sky": 5198958,
  "fog": 4803682,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 8487826,
  "sunIntensity": 2,
  "hemiSky": 6645886,
  "hemiGround": 2106154,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2171433,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.06
  },
  "daylight": false,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "junglecamp": {
  "roles": {
   "cover": 8750336,
   "exterior_wall": 8353592,
   "floor": 8755731,
   "glass": 5918762,
   "ramp": 7825975,
   "riser": 8562197,
   "roof": 4737033,
   "soft_panel": 8749824,
   "stair": 7762743,
   "static_hard": 9340734
  },
  "sky": 4143655,
  "fog": 3617828,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5328450,
  "sunIntensity": 2,
  "hemiSky": 4670259,
  "hemiGround": 3093775,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 920839,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "junglecompound": {
  "roles": {
   "cover": 3876701,
   "exterior_wall": 5653340,
   "floor": 5262655,
   "glass": 11117765,
   "ramp": 7229808,
   "riser": 5327422,
   "roof": 3026211,
   "soft_panel": 3941983,
   "stair": 7362165,
   "static_hard": 6573418
  },
  "sky": 8354205,
  "fog": 7433358,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 13092557,
  "sunIntensity": 2.6,
  "hemiSky": 10526384,
  "hemiGround": 2302493,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1446423,
   "alpha": 0.2,
   "scale": 1.9
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "jura": {
  "roles": {
   "cover": 1865424,
   "exterior_wall": 12434620,
   "floor": 11180163,
   "glass": 8764132,
   "ramp": 12763585,
   "riser": 12233115,
   "roof": 9471586,
   "soft_panel": 4035818,
   "stair": 12829121,
   "static_hard": 13092550
  },
  "sky": 5935293,
  "fog": 5079726,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12635092,
  "sunIntensity": 2.6,
  "hemiSky": 9284290,
  "hemiGround": 8746854,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2894378,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "lake": {
  "roles": {
   "cover": 4560080,
   "exterior_wall": 6912378,
   "floor": 3953500,
   "glass": 10601952,
   "ramp": 8031629,
   "riser": 5007221,
   "roof": 3098442,
   "soft_panel": 8041696,
   "stair": 8425874,
   "static_hard": 7702152
  },
  "sky": 7313849,
  "fog": 6261675,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 13687005,
  "sunIntensity": 2.6,
  "hemiSky": 10466500,
  "hemiGround": 3292996,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1711389,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "library": {
  "roles": {
   "cover": 8396548,
   "exterior_wall": 8213050,
   "floor": 9461826,
   "glass": 4927005,
   "ramp": 7751479,
   "riser": 11237455,
   "roof": 5781031,
   "soft_panel": 8593153,
   "stair": 7818550,
   "static_hard": 9197888
  },
  "sky": 3417372,
  "fog": 3023130,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 4339762,
  "sunIntensity": 2,
  "hemiSky": 3812646,
  "hemiGround": 5192493,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1380108,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.08
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "lite": {
  "roles": {
   "cover": 8716295,
   "exterior_wall": 3820413,
   "floor": 6247527,
   "glass": 2042457,
   "ramp": 3556215,
   "riser": 7628669,
   "roof": 3682876,
   "soft_panel": 8716297,
   "stair": 3556983,
   "static_hard": 4280715
  },
  "sky": 2106685,
  "fog": 1974838,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3816781,
  "sunIntensity": 2,
  "hemiSky": 2830404,
  "hemiGround": 3551801,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 658194,
   "alpha": 0.2,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.02
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "gable",
   "barrel",
   "arcade"
  ],
  "accent": 10747913
 },
 "log": {
  "roles": {
   "cover": 10709520,
   "exterior_wall": 6516552,
   "floor": 9735293,
   "glass": 4212783,
   "ramp": 6252358,
   "riser": 10722957,
   "roof": 7103064,
   "soft_panel": 13665552,
   "stair": 6055495,
   "static_hard": 7306065
  },
  "sky": 3159079,
  "fog": 2829860,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 4474430,
  "sunIntensity": 2,
  "hemiSky": 3750961,
  "hemiGround": 6709592,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 855562,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "lunacy": {
  "roles": {
   "cover": 2050405,
   "exterior_wall": 5333863,
   "floor": 5073271,
   "glass": 2306356,
   "ramp": 5135456,
   "riser": 6126992,
   "roof": 3163724,
   "soft_panel": 2183023,
   "stair": 5135712,
   "static_hard": 5992049
  },
  "sky": 1909798,
  "fog": 1712418,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3027507,
  "sunIntensity": 2,
  "hemiSky": 2370348,
  "hemiGround": 3358790,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 855823,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "mansion": {
  "roles": {
   "cover": 8735488,
   "exterior_wall": 5854016,
   "floor": 6446636,
   "glass": 12562585,
   "ramp": 5459004,
   "riser": 6577707,
   "roof": 3683354,
   "soft_panel": 8735488,
   "stair": 5853760,
   "static_hard": 6643273
  },
  "sky": 9930610,
  "fog": 8944231,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12960188,
  "sunIntensity": 2.6,
  "hemiSky": 11116949,
  "hemiGround": 1315595,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 986636,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "marquis": {
  "roles": {
   "cover": 3706279,
   "exterior_wall": 12042938,
   "floor": 8819601,
   "glass": 15001317,
   "ramp": 12567743,
   "riser": 9938081,
   "roof": 6253418,
   "soft_panel": 5155783,
   "stair": 12567743,
   "static_hard": 12962245
  },
  "sky": 11383984,
  "fog": 10199710,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15921906,
  "sunIntensity": 2.6,
  "hemiSky": 13817299,
  "hemiGround": 6186853,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4344389,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "memento": {
  "roles": {
   "cover": 6914308,
   "exterior_wall": 5793609,
   "floor": 4346939,
   "glass": 14018038,
   "ramp": 6716503,
   "riser": 4477756,
   "roof": 2570022,
   "soft_panel": 6979843,
   "stair": 7242332,
   "static_hard": 6583636
  },
  "sky": 9285844,
  "fog": 7904966,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15790837,
  "sunIntensity": 2.6,
  "hemiSky": 13030625,
  "hemiGround": 2765607,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1316626,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "miami": {
  "roles": {
   "cover": 8476473,
   "exterior_wall": 10197916,
   "floor": 6907490,
   "glass": 4607575,
   "ramp": 12171706,
   "riser": 7762542,
   "roof": 4934471,
   "soft_panel": 10775876,
   "stair": 12698050,
   "static_hard": 11579569
  },
  "sky": 3685441,
  "fog": 3356218,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5592922,
  "sunIntensity": 2,
  "hemiSky": 4540492,
  "hemiGround": 4802629,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2697513,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.02
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "mikla": {
  "roles": {
   "floor": 11844802,
   "roof": 4869714,
   "static_hard": 13159632,
   "exterior_wall": 11186358,
   "riser": 12633804,
   "stair": 12896976,
   "ramp": 12568011,
   "cover": 5914412,
   "soft_panel": 8016440,
   "glass": 13690612
  },
  "sky": 13490402,
  "fog": 12766936,
  "fogNear": 28,
  "fogFar": 155,
  "sun": 16777215,
  "sunIntensity": 2.7,
  "hemiSky": 14674676,
  "hemiGround": 6712434,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 4474956,
   "alpha": 0.15,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.02
  },
  "daylight": true,
  "look": "A Scandinavian street in the cold. Dark timber, pale render, snow light.",
  "skyline": [
   "minaret",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11561520,
  "curated": true
 },
 "militia": {
  "roles": {
   "floor": 8024160,
   "roof": 5129786,
   "static_hard": 10128244,
   "exterior_wall": 8615519,
   "riser": 9076587,
   "stair": 9536364,
   "ramp": 9207656,
   "cover": 5915430,
   "soft_panel": 5005621,
   "glass": 11847884
  },
  "sky": 10135708,
  "fog": 9214608,
  "fogNear": 26,
  "fogFar": 145,
  "sun": 15922400,
  "sunIntensity": 2.4,
  "hemiSky": 13162692,
  "hemiGround": 4867130,
  "hemiIntensity": 2.7,
  "grid": {
   "line": 3814699,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0
  },
  "daylight": true,
  "look": "A backwoods farmhouse. Timber siding, damp earth, moss, overcast.",
  "skyline": [
   "water_tank",
   "silo"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "barrel",
   "arcade"
  ],
  "accent": 9067060,
  "curated": true
 },
 "militia_winter": {
  "roles": {
   "cover": 16731953,
   "exterior_wall": 4933999,
   "floor": 6975897,
   "glass": 4407412,
   "ramp": 4802662,
   "riser": 8029352,
   "roof": 5000815,
   "soft_panel": 16741724,
   "stair": 4868198,
   "static_hard": 5722746
  },
  "sky": 3815507,
  "fog": 3486537,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6118509,
  "sunIntensity": 2,
  "hemiSky": 4868190,
  "hemiGround": 5132902,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 657933,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "mills": {
  "roles": {
   "cover": 6076671,
   "exterior_wall": 8050175,
   "floor": 5791579,
   "glass": 15071231,
   "ramp": 9363190,
   "riser": 6515559,
   "roof": 4211776,
   "soft_panel": 6076415,
   "stair": 9360374,
   "static_hard": 9689851
  },
  "sky": 10082550,
  "fog": 8112108,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15594743,
  "sunIntensity": 2.6,
  "hemiSky": 15135480,
  "hemiGround": 4145728,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1471629,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "mirage": {
  "roles": {
   "floor": 14997181,
   "roof": 11561532,
   "static_hard": 15722198,
   "exterior_wall": 14536632,
   "riser": 15721677,
   "stair": 15260868,
   "ramp": 14997696,
   "cover": 11102266,
   "soft_panel": 13208142,
   "glass": 10474728
  },
  "sky": 12178408,
  "fog": 15129023,
  "fogNear": 46,
  "fogFar": 220,
  "sun": 16774880,
  "sunIntensity": 3.2,
  "hemiSky": 14215413,
  "hemiGround": 10259048,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 8021575,
   "alpha": 0.12,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.92,
   "metalness": 0
  },
  "daylight": true,
  "look": "Moroccan rooftops. Whitewashed plaster, terracotta trim, sand underfoot, a very bright sky.",
  "skyline": [
   "minaret",
   "campanile",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "arcade",
   "chamfer",
   "curved",
   "gable"
  ],
  "accent": 12739642,
  "curated": true
 },
 "mist": {
  "roles": {
   "cover": 5592118,
   "exterior_wall": 11518410,
   "floor": 4279886,
   "glass": 13163235,
   "ramp": 12305609,
   "riser": 4214094,
   "roof": 2436396,
   "soft_panel": 7039298,
   "stair": 12109515,
   "static_hard": 12372690
  },
  "sky": 9546424,
  "fog": 8428200,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15593456,
  "sunIntensity": 2.6,
  "hemiSky": 12437710,
  "hemiGround": 1974818,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3029310,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "mocha": {
  "roles": {
   "cover": 7826189,
   "exterior_wall": 7562310,
   "floor": 13349264,
   "glass": 11456509,
   "ramp": 8812374,
   "riser": 14272170,
   "roof": 11704166,
   "soft_panel": 8943885,
   "stair": 9206875,
   "static_hard": 8548944
  },
  "sky": 6986718,
  "fog": 5671633,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15330803,
  "sunIntensity": 2.6,
  "hemiSky": 11256287,
  "hemiGround": 12496277,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1907220,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "monastery": {
  "roles": {
   "cover": 12548906,
   "exterior_wall": 11912389,
   "floor": 4672069,
   "glass": 13885668,
   "ramp": 12437447,
   "riser": 4475716,
   "roof": 2698023,
   "soft_panel": 14325834,
   "stair": 12437191,
   "static_hard": 12831435
  },
  "sky": 10268598,
  "fog": 9084838,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856627,
  "sunIntensity": 2.6,
  "hemiSky": 12963280,
  "hemiGround": 1974301,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4082250,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "motel": {
  "roles": {
   "cover": 7553042,
   "exterior_wall": 7430994,
   "floor": 4802374,
   "glass": 16185070,
   "ramp": 8812640,
   "riser": 5328718,
   "roof": 4013115,
   "soft_panel": 9063443,
   "stair": 9141093,
   "static_hard": 8417372
  },
  "sky": 13619642,
  "fog": 12501156,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15987697,
  "sunIntensity": 2.6,
  "hemiSky": 15724522,
  "hemiGround": 3947066,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1447186,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "water_tank",
   "spire"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 12739642
 },
 "museum": {
  "roles": {
   "cover": 6772510,
   "exterior_wall": 10394250,
   "floor": 15517551,
   "glass": 13426152,
   "ramp": 11974059,
   "riser": 16174990,
   "roof": 15187250,
   "soft_panel": 8416034,
   "stair": 12500147,
   "static_hard": 11578785
  },
  "sky": 9612222,
  "fog": 8428207,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856372,
  "sunIntensity": 2.6,
  "hemiSky": 12635091,
  "hemiGround": 14334329,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2763045,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "mutiny": {
  "roles": {
   "cover": 7552786,
   "exterior_wall": 8839412,
   "floor": 5197119,
   "glass": 15397883,
   "ramp": 9950700,
   "riser": 5393213,
   "roof": 3026467,
   "soft_panel": 8012560,
   "stair": 9953004,
   "static_hard": 10282482
  },
  "sky": 11126748,
  "fog": 9549006,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15791093,
  "sunIntensity": 2.6,
  "hemiSky": 14937072,
  "hemiGround": 2696994,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2122622,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "nuke": {
  "roles": {
   "floor": 10133668,
   "roof": 7173240,
   "static_hard": 11778493,
   "exterior_wall": 9409945,
   "riser": 11054770,
   "stair": 10397097,
   "ramp": 10133925,
   "cover": 13149996,
   "soft_panel": 13940026,
   "glass": 12114152
  },
  "sky": 9349309,
  "fog": 10464696,
  "fogNear": 34,
  "fogFar": 170,
  "sun": 15660282,
  "sunIntensity": 2.7,
  "hemiSky": 13491690,
  "hemiGround": 5923173,
  "hemiIntensity": 2.8,
  "grid": {
   "line": 4014920,
   "alpha": 0.2,
   "scale": 2.4
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.08
  },
  "daylight": true,
  "look": "A nuclear plant. Poured concrete, cold fluorescent light, yellow hazard paint, steel.",
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668,
  "curated": true
 },
 "office": {
  "roles": {
   "floor": 10134444,
   "roof": 7304829,
   "static_hard": 13485752,
   "exterior_wall": 11840928,
   "riser": 11055288,
   "stair": 12104358,
   "ramp": 11841186,
   "cover": 9058868,
   "soft_panel": 12757112,
   "glass": 13624562
  },
  "sky": 14214895,
  "fog": 13162208,
  "fogNear": 26,
  "fogFar": 140,
  "sun": 16777215,
  "sunIntensity": 2.6,
  "hemiSky": 14872310,
  "hemiGround": 6975348,
  "hemiIntensity": 3,
  "grid": {
   "line": 4869972,
   "alpha": 0.14,
   "scale": 1
  },
  "surface": {
   "roughness": 0.82,
   "metalness": 0.02
  },
  "daylight": true,
  "look": "A snowbound office park. Flat carpet, beige partitions, fluorescent light, snow glare outside.",
  "skyline": [
   "water_tank",
   "chimney",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772,
  "curated": true
 },
 "oil": {
  "roles": {
   "cover": 8399876,
   "exterior_wall": 8017725,
   "floor": 7428925,
   "glass": 7036516,
   "ramp": 7622201,
   "riser": 7299134,
   "roof": 3418142,
   "soft_panel": 8530946,
   "stair": 7886139,
   "static_hard": 8937796
  },
  "sky": 5327437,
  "fog": 4735814,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 7499376,
  "sunIntensity": 2,
  "hemiSky": 6249053,
  "hemiGround": 2893342,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1051658,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "oilrig": {
  "roles": {
   "cover": 3620685,
   "exterior_wall": 6187396,
   "floor": 4541544,
   "glass": 2767719,
   "ramp": 7239831,
   "riser": 4937074,
   "roof": 3092806,
   "soft_panel": 3686224,
   "stair": 7635099,
   "static_hard": 6911378
  },
  "sky": 2634055,
  "fog": 2501951,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 4672859,
  "sunIntensity": 2,
  "hemiSky": 3554896,
  "hemiGround": 3159105,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1579551,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0.04
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "otaku": {
  "roles": {
   "cover": 9728256,
   "exterior_wall": 7947307,
   "floor": 5066049,
   "glass": 15528696,
   "ramp": 8998458,
   "riser": 5131840,
   "roof": 2894629,
   "soft_panel": 12160256,
   "stair": 9394237,
   "static_hard": 8802099
  },
  "sky": 10992338,
  "fog": 9545667,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15790836,
  "sunIntensity": 2.6,
  "hemiSky": 14476009,
  "hemiGround": 2039579,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1905166,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "overgrown": {
  "roles": {
   "cover": 6644000,
   "exterior_wall": 9749989,
   "floor": 5132351,
   "glass": 15463417,
   "ramp": 10603491,
   "riser": 5592643,
   "roof": 3618604,
   "soft_panel": 7499041,
   "stair": 10602979,
   "static_hard": 11128549
  },
  "sky": 12242910,
  "fog": 10599630,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15791092,
  "sunIntensity": 2.6,
  "hemiSky": 15725557,
  "hemiGround": 3421228,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2906738,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "overpass": {
  "roles": {
   "floor": 10264216,
   "roof": 7237739,
   "static_hard": 11580076,
   "exterior_wall": 9737871,
   "riser": 10922146,
   "stair": 10658974,
   "ramp": 10395801,
   "cover": 5008186,
   "soft_panel": 7311180,
   "glass": 10471640
  },
  "sky": 11583692,
  "fog": 11056832,
  "fogNear": 34,
  "fogFar": 180,
  "sun": 15791608,
  "sunIntensity": 2.5,
  "hemiSky": 13359844,
  "hemiGround": 6053720,
  "hemiIntensity": 2.7,
  "grid": {
   "line": 4474431,
   "alpha": 0.17,
   "scale": 2
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.03
  },
  "daylight": true,
  "look": "A German park under a motorway. Wet concrete, clipped grass, canal water.",
  "skyline": [
   "campanile",
   "crane",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "curved",
   "terrace",
   "helipad"
  ],
  "accent": 4161471,
  "curated": true
 },
 "palacio": {
  "roles": {
   "cover": 554741,
   "exterior_wall": 6711427,
   "floor": 13613196,
   "glass": 8303087,
   "ramp": 8355736,
   "riser": 14469288,
   "roof": 12363100,
   "soft_panel": 4102398,
   "stair": 8816285,
   "static_hard": 7764115
  },
  "sky": 5277641,
  "fog": 4356538,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12569304,
  "sunIntensity": 2.6,
  "hemiSky": 8955592,
  "hemiGround": 11639407,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1842210,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "palais": {
  "roles": {
   "cover": 6306097,
   "exterior_wall": 8553599,
   "floor": 6445908,
   "glass": 15069951,
   "ramp": 9737872,
   "riser": 7958118,
   "roof": 4999232,
   "soft_panel": 7882300,
   "stair": 10066838,
   "static_hard": 9408908
  },
  "sky": 14938365,
  "fog": 12245238,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15594231,
  "sunIntensity": 2.6,
  "hemiSky": 15463162,
  "hemiGround": 4801856,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2105375,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "penal": {
  "roles": {
   "cover": 6071551,
   "exterior_wall": 5853248,
   "floor": 5591610,
   "glass": 15069695,
   "ramp": 6642759,
   "riser": 5656889,
   "roof": 3157793,
   "soft_panel": 6071807,
   "stair": 7036748,
   "static_hard": 6708040
  },
  "sky": 11719935,
  "fog": 9289208,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15594232,
  "sunIntensity": 2.6,
  "hemiSky": 15331835,
  "hemiGround": 1907734,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1249807,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "phoenix_compound": {
  "roles": {
   "cover": 5597102,
   "exterior_wall": 6315904,
   "floor": 4144466,
   "glass": 7306433,
   "ramp": 7698069,
   "riser": 4143956,
   "roof": 2303023,
   "soft_panel": 8359365,
   "stair": 8223898,
   "static_hard": 7105681
  },
  "sky": 5595284,
  "fog": 5265795,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 10462132,
  "sunIntensity": 2.6,
  "hemiSky": 7831202,
  "hemiGround": 1776161,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1710881,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "phoenix_facility": {
  "roles": {
   "cover": 31621,
   "exterior_wall": 3505282,
   "floor": 5266768,
   "glass": 862506,
   "ramp": 3307132,
   "riser": 5136462,
   "roof": 2371108,
   "soft_panel": 31109,
   "stair": 3306876,
   "static_hard": 3902097
  },
  "sky": 859165,
  "fog": 858137,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 1712931,
  "sunIntensity": 2,
  "hemiSky": 1253152,
  "hemiGround": 1448213,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 330251,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "pipeline": {
  "roles": {
   "cover": 4753903,
   "exterior_wall": 6117457,
   "floor": 5195583,
   "glass": 11455477,
   "ramp": 7235682,
   "riser": 5261375,
   "roof": 3024420,
   "soft_panel": 6659574,
   "stair": 7564903,
   "static_hard": 6906973
  },
  "sky": 7378898,
  "fog": 6194885,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15067631,
  "sunIntensity": 2.6,
  "hemiSky": 11255256,
  "hemiGround": 2038810,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1578774,
   "alpha": 0.2,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "piranesi": {
  "roles": {
   "floor": 10658972,
   "roof": 7237738,
   "static_hard": 12369588,
   "exterior_wall": 10527384,
   "riser": 11448486,
   "stair": 11711658,
   "ramp": 11382693,
   "cover": 4881002,
   "soft_panel": 9080704,
   "glass": 12637404
  },
  "sky": 11450556,
  "fog": 10924212,
  "fogNear": 32,
  "fogFar": 175,
  "sun": 16054002,
  "sunIntensity": 2.5,
  "hemiSky": 13490910,
  "hemiGround": 6185050,
  "hemiIntensity": 2.7,
  "grid": {
   "line": 4145468,
   "alpha": 0.18,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.02
  },
  "daylight": true,
  "look": "Baroque stonework and statuary. Cool marble, verdigris bronze, grey sky.",
  "skyline": [
   "obelisk",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "setback"
  ],
  "accent": 10250812,
  "curated": true
 },
 "pitstop": {
  "roles": {
   "cover": 8716296,
   "exterior_wall": 6444632,
   "floor": 11116442,
   "glass": 5714485,
   "ramp": 6116180,
   "riser": 12300462,
   "roof": 8287338,
   "soft_panel": 9437193,
   "stair": 6379353,
   "static_hard": 7102561
  },
  "sky": 4074285,
  "fog": 3614761,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5457479,
  "sunIntensity": 2,
  "hemiSky": 4667193,
  "hemiGround": 7827050,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1381139,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "pool_day": {
  "roles": {
   "cover": 4998209,
   "exterior_wall": 10525859,
   "floor": 12496029,
   "glass": 9411760,
   "ramp": 12565952,
   "riser": 13353144,
   "roof": 10655095,
   "soft_panel": 6248018,
   "stair": 12763331,
   "static_hard": 12039351
  },
  "sky": 7108745,
  "fog": 6515834,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 11448758,
  "sunIntensity": 2.6,
  "hemiSky": 9147036,
  "hemiGround": 11510678,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2828587,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "crane",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "helipad",
   "sawtooth",
   "drum"
  ],
  "accent": 6312268
 },
 "port": {
  "roles": {
   "cover": 7675151,
   "exterior_wall": 11518410,
   "floor": 4345161,
   "glass": 15659766,
   "ramp": 12109771,
   "riser": 4214604,
   "roof": 2501673,
   "soft_panel": 7871756,
   "stair": 12109515,
   "static_hard": 12503760
  },
  "sky": 11779275,
  "fog": 10397881,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856371,
  "sunIntensity": 2.6,
  "hemiSky": 14869736,
  "hemiGround": 1316374,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4412248,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "poseidon": {
  "roles": {
   "cover": 3637702,
   "exterior_wall": 11386061,
   "floor": 11119026,
   "glass": 9156317,
   "ramp": 11847632,
   "riser": 12566213,
   "roof": 9080206,
   "soft_panel": 6726103,
   "stair": 11846864,
   "static_hard": 12241108
  },
  "sky": 6327733,
  "fog": 5537701,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12634578,
  "sunIntensity": 2.6,
  "hemiSky": 9480125,
  "hemiGround": 11053483,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3622738,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "prison": {
  "roles": {
   "cover": 5267272,
   "exterior_wall": 7041640,
   "floor": 6052434,
   "glass": 725002,
   "ramp": 8094841,
   "riser": 6250070,
   "roof": 4342074,
   "soft_panel": 6649946,
   "stair": 8423806,
   "static_hard": 7765876
  },
  "sky": 592648,
  "fog": 526856,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 855821,
  "sunIntensity": 2,
  "hemiSky": 724234,
  "hemiGround": 4144698,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1579288,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "prodigy": {
  "roles": {
   "floor": 8818054,
   "roof": 5988699,
   "static_hard": 10133913,
   "exterior_wall": 8423296,
   "riser": 9410190,
   "stair": 9673362,
   "ramp": 9410190,
   "cover": 4153195,
   "soft_panel": 5795962,
   "glass": 11063512
  },
  "sky": 8293520,
  "fog": 7898762,
  "fogNear": 24,
  "fogFar": 130,
  "sun": 15003376,
  "sunIntensity": 2.3,
  "hemiSky": 12374228,
  "hemiGround": 5001804,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 3422772,
   "alpha": 0.22,
   "scale": 2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.06
  },
  "daylight": true,
  "look": "A concrete research bunker. Institutional grey-green, strip lighting, sealed doors.",
  "skyline": [
   "chimney",
   "silo",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "drum",
   "helipad"
  ],
  "accent": 13205804,
  "curated": true
 },
 "quarry": {
  "roles": {
   "cover": 8142344,
   "exterior_wall": 7952958,
   "floor": 7820354,
   "glass": 6313814,
   "ramp": 7427900,
   "riser": 9594193,
   "roof": 4469286,
   "soft_panel": 8339206,
   "stair": 7427389,
   "static_hard": 8807494
  },
  "sky": 4801603,
  "fog": 4275517,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6775908,
  "sunIntensity": 2,
  "hemiSky": 5657170,
  "hemiGround": 4075561,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1117707,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "radio_hostage_rescue_map": {
  "roles": {
   "cover": 7095576,
   "exterior_wall": 7498343,
   "floor": 4671558,
   "glass": 9998214,
   "ramp": 8682872,
   "riser": 5921881,
   "roof": 3816506,
   "soft_panel": 7817752,
   "stair": 9011581,
   "static_hard": 8353651
  },
  "sky": 7630440,
  "fog": 6841182,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 10657950,
  "sunIntensity": 2.6,
  "hemiSky": 9012352,
  "hemiGround": 3750456,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1775897,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "railroad": {
  "roles": {
   "cover": 8475139,
   "exterior_wall": 6052157,
   "floor": 12763289,
   "glass": 15528696,
   "ramp": 6447684,
   "riser": 13815217,
   "roof": 9870687,
   "soft_panel": 10511616,
   "stair": 6775624,
   "static_hard": 6841414
  },
  "sky": 12504798,
  "fog": 10795470,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15790836,
  "sunIntensity": 2.6,
  "hemiSky": 15725301,
  "hemiGround": 9473380,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1381648,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "rails": {
  "roles": {
   "cover": 3952739,
   "exterior_wall": 5463141,
   "floor": 6776160,
   "glass": 4212310,
   "ramp": 5199966,
   "riser": 8158068,
   "roof": 3749942,
   "soft_panel": 4875389,
   "stair": 5199455,
   "static_hard": 6121071
  },
  "sky": 3422015,
  "fog": 3093048,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5263959,
  "sunIntensity": 2,
  "hemiSky": 4211530,
  "hemiGround": 3618357,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1052946,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.08
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "range": {
  "roles": {
   "cover": 8727552,
   "exterior_wall": 6447957,
   "floor": 10459542,
   "glass": 1508610,
   "ramp": 6575945,
   "riser": 11709864,
   "roof": 7695466,
   "soft_panel": 8727808,
   "stair": 6053200,
   "static_hard": 7171678
  },
  "sky": 918788,
  "fog": 787716,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 1051402,
  "sunIntensity": 2,
  "hemiSky": 985095,
  "hemiGround": 7367528,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 526343,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "chimney",
   "silo"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "barrel",
   "arcade"
  ],
  "accent": 10761728
 },
 "ravine": {
  "roles": {
   "cover": 10700558,
   "exterior_wall": 7821389,
   "floor": 7621946,
   "glass": 5395569,
   "ramp": 9266523,
   "riser": 7556666,
   "roof": 5321002,
   "soft_panel": 13719310,
   "stair": 9661535,
   "static_hard": 8872791
  },
  "sky": 4408403,
  "fog": 4013642,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6842482,
  "sunIntensity": 2,
  "hemiSky": 5461089,
  "hemiGround": 4863534,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1511953,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "resort": {
  "roles": {
   "cover": 4359652,
   "exterior_wall": 5790029,
   "floor": 5064770,
   "glass": 11717356,
   "ramp": 7039838,
   "riser": 5065026,
   "roof": 3288363,
   "soft_panel": 7185390,
   "stair": 7303523,
   "static_hard": 6645337
  },
  "sky": 7969222,
  "fog": 6785464,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 14870251,
  "sunIntensity": 2.6,
  "hemiSky": 11386065,
  "hemiGround": 3091755,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1184273,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "rialto": {
  "roles": {
   "cover": 6077439,
   "exterior_wall": 8052223,
   "floor": 8421487,
   "glass": 15070975,
   "ramp": 9363190,
   "riser": 9408381,
   "roof": 6052688,
   "soft_panel": 6076927,
   "stair": 9362422,
   "static_hard": 9691899
  },
  "sky": 9360634,
  "fog": 7390450,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15594744,
  "sunIntensity": 2.6,
  "hemiSky": 14675960,
  "hemiGround": 5789776,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1337472,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "riverside": {
  "roles": {
   "cover": 8744192,
   "exterior_wall": 7367721,
   "floor": 5459516,
   "glass": 10260893,
   "ramp": 6970405,
   "riser": 6644296,
   "roof": 3090722,
   "soft_panel": 8744704,
   "stair": 6907686,
   "static_hard": 8289072
  },
  "sky": 7892857,
  "fog": 7103852,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 11184042,
  "sunIntensity": 2.6,
  "hemiSky": 9341071,
  "hemiGround": 2894370,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 657669,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "water_tank",
   "spire"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 12739642
 },
 "rockworld": {
  "roles": {
   "cover": 7173655,
   "exterior_wall": 11379038,
   "floor": 8221761,
   "glass": 9537847,
   "ramp": 12168821,
   "riser": 9998159,
   "roof": 7234617,
   "soft_panel": 9148186,
   "stair": 12366717,
   "static_hard": 11906159
  },
  "sky": 6578230,
  "fog": 5788979,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 8354913,
  "sunIntensity": 2,
  "hemiSky": 7367753,
  "hemiGround": 6577983,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2368022,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.08
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "rooftop": {
  "roles": {
   "cover": 3697327,
   "exterior_wall": 13087422,
   "floor": 13993623,
   "glass": 15855349,
   "ramp": 13351111,
   "riser": 14721966,
   "roof": 12801392,
   "soft_panel": 5539788,
   "stair": 13351110,
   "static_hard": 13680330
  },
  "sky": 12234437,
  "fog": 10984116,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15921651,
  "sunIntensity": 2.6,
  "hemiSky": 14670818,
  "hemiGround": 13077652,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4996169,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "rooftop_control": {
  "roles": {
   "cover": 2774112,
   "exterior_wall": 9230062,
   "floor": 8230285,
   "glass": 15463673,
   "ramp": 10014443,
   "riser": 9348508,
   "roof": 5795177,
   "soft_panel": 3369338,
   "stair": 10016235,
   "static_hard": 10279410
  },
  "sky": 13163493,
  "fog": 11388885,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15791092,
  "sunIntensity": 2.6,
  "hemiSky": 15725557,
  "hemiGround": 5859170,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2515839,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "rooftops": {
  "roles": {
   "cover": 1844073,
   "exterior_wall": 9674653,
   "floor": 8223857,
   "glass": 12834258,
   "ramp": 11713207,
   "riser": 9211007,
   "roof": 5921105,
   "soft_panel": 1711979,
   "stair": 12305344,
   "static_hard": 11121327
  },
  "sky": 9611429,
  "fog": 8493462,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 14869989,
  "sunIntensity": 2.6,
  "hemiSky": 12042944,
  "hemiGround": 5658192,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2566697,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "rotterdam": {
  "roles": {
   "cover": 621598,
   "exterior_wall": 4277879,
   "floor": 4214637,
   "glass": 1516604,
   "ramp": 4015984,
   "riser": 4278893,
   "roof": 1911093,
   "soft_panel": 430113,
   "stair": 3948913,
   "static_hard": 4673157
  },
  "sky": 1514793,
  "fog": 1382948,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2632757,
  "sunIntensity": 2,
  "hemiSky": 1975342,
  "hemiGround": 1514274,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 526605,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "royal": {
  "roles": {
   "cover": 4276548,
   "exterior_wall": 5987677,
   "floor": 11382189,
   "glass": 3948613,
   "ramp": 5593176,
   "riser": 12763842,
   "roof": 9145998,
   "soft_panel": 5066323,
   "stair": 5658455,
   "static_hard": 6579816
  },
  "sky": 3092788,
  "fog": 2829359,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 4606026,
  "sunIntensity": 2,
  "hemiSky": 3816254,
  "hemiGround": 11119530,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 921359,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "rubble": {
  "roles": {
   "cover": 1850217,
   "exterior_wall": 6839119,
   "floor": 6575945,
   "glass": 2699068,
   "ramp": 6379341,
   "riser": 6575946,
   "roof": 3090467,
   "soft_panel": 2049922,
   "stair": 6378829,
   "static_hard": 7497050
  },
  "sky": 2237740,
  "fog": 2040359,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3487547,
  "sunIntensity": 2,
  "hemiSky": 2764083,
  "hemiGround": 855051,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 526343,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "ruins": {
  "roles": {
   "cover": 7171861,
   "exterior_wall": 6909514,
   "floor": 10131336,
   "glass": 5132327,
   "ramp": 6579274,
   "riser": 11250074,
   "roof": 7433056,
   "soft_panel": 7369235,
   "stair": 6645064,
   "static_hard": 7764307
  },
  "sky": 3618851,
  "fog": 3224097,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 4737340,
  "sunIntensity": 2,
  "hemiSky": 4145198,
  "hemiGround": 7039328,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1250063,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "chimney",
   "silo"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "setback",
   "tower",
   "chamfer"
  ],
  "accent": 10461952
 },
 "rush": {
  "roles": {
   "cover": 8614401,
   "exterior_wall": 7237193,
   "floor": 12235144,
   "glass": 4474932,
   "ramp": 6644296,
   "riser": 13289631,
   "roof": 9665366,
   "soft_panel": 8746240,
   "stair": 6513992,
   "static_hard": 7829843
  },
  "sky": 3355946,
  "fog": 2961191,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 4671554,
  "sunIntensity": 2,
  "hemiSky": 3947829,
  "hemiGround": 8814427,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 855306,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.08
  },
  "daylight": false,
  "skyline": [
   "water_tank",
   "chimney"
  ],
  "facade": "industrial",
  "roofs": "pitched",
  "blocks": [
   "helipad",
   "sawtooth",
   "drum"
  ],
  "accent": 10718464
 },
 "safehouse": {
  "roles": {
   "cover": 6710815,
   "exterior_wall": 6382676,
   "floor": 8157541,
   "glass": 7238468,
   "ramp": 6053200,
   "riser": 9210223,
   "roof": 5920328,
   "soft_panel": 7171359,
   "stair": 5987664,
   "static_hard": 7106397
  },
  "sky": 5263931,
  "fog": 4671798,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 7106143,
  "sunIntensity": 2,
  "hemiSky": 6053451,
  "hemiGround": 5526345,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1118735,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "sanctum": {
  "roles": {
   "cover": 7884079,
   "exterior_wall": 7169899,
   "floor": 5063240,
   "glass": 15789550,
   "ramp": 8353917,
   "riser": 6312280,
   "roof": 4273725,
   "soft_panel": 9985849,
   "stair": 8682882,
   "static_hard": 8024952
  },
  "sky": 12432054,
  "fog": 11247524,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15987442,
  "sunIntensity": 2.6,
  "hemiSky": 14605020,
  "hemiGround": 4011578,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1644568,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "obelisk",
   "ziggurat",
   "minaret"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "chamfer"
  ],
  "accent": 13805111
 },
 "santorini": {
  "roles": {
   "cover": 6906396,
   "exterior_wall": 12041666,
   "floor": 12234145,
   "glass": 15594488,
   "ramp": 12370888,
   "riser": 13353400,
   "roof": 10457209,
   "soft_panel": 7038233,
   "stair": 12501702,
   "static_hard": 12765388
  },
  "sky": 12636380,
  "fog": 10992844,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856372,
  "sunIntensity": 2.6,
  "hemiSky": 15791093,
  "hemiGround": 11840416,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3488058,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "seaside": {
  "roles": {
   "cover": 14455367,
   "exterior_wall": 12042944,
   "floor": 5196608,
   "glass": 15660022,
   "ramp": 12567748,
   "riser": 5262654,
   "roof": 3354409,
   "soft_panel": 15118452,
   "stair": 12567748,
   "static_hard": 12962249
  },
  "sky": 12767190,
  "fog": 11254724,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856627,
  "sunIntensity": 2.6,
  "hemiSky": 15856628,
  "hemiGround": 3157545,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4475980,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "water_tank",
   "spire"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 12739642
 },
 "season": {
  "roles": {
   "floor": 5792367,
   "roof": 3752527,
   "static_hard": 7239813,
   "exterior_wall": 6516090,
   "riser": 7897743,
   "stair": 8095122,
   "ramp": 7437192,
   "cover": 12881716,
   "soft_panel": 11042607,
   "glass": 4842224
  },
  "sky": 1581107,
  "fog": 2502719,
  "fogNear": 34,
  "fogFar": 190,
  "sun": 12112639,
  "sunIntensity": 1.8,
  "hemiSky": 5206426,
  "hemiGround": 2370618,
  "hemiIntensity": 3.2,
  "grid": {
   "line": 2500908,
   "alpha": 0.24,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.7,
   "metalness": 0.12
  },
  "daylight": false,
  "look": "A rain-slick Asian street at dusk. Wet asphalt, neon signage, concrete.",
  "skyline": [
   "water_tank",
   "chimney",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "glassbox"
  ],
  "accent": 16727406,
  "curated": true
 },
 "ship": {
  "roles": {
   "cover": 7885581,
   "exterior_wall": 13153457,
   "floor": 4343885,
   "glass": 15261149,
   "ramp": 13351096,
   "riser": 4279373,
   "roof": 2566443,
   "soft_panel": 9462540,
   "stair": 13351096,
   "static_hard": 13681598
  },
  "sky": 12166053,
  "fog": 11112851,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15987186,
  "sunIntensity": 2.6,
  "hemiSky": 14011597,
  "hemiGround": 1842719,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4667190,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.03
  },
  "daylight": true,
  "skyline": [
   "water_tank",
   "chimney"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "chamfer",
   "curved",
   "setback"
  ],
  "accent": 10775296
 },
 "shipped": {
  "roles": {
   "cover": 7482643,
   "exterior_wall": 5327432,
   "floor": 8217436,
   "glass": 14738145,
   "ramp": 4933187,
   "riser": 9794925,
   "roof": 4996408,
   "soft_panel": 8860948,
   "stair": 4998467,
   "static_hard": 6050897
  },
  "sky": 11251884,
  "fog": 10067867,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15921906,
  "sunIntensity": 2.6,
  "hemiSky": 13619663,
  "hemiGround": 4668473,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1184017,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "shoothouse": {
  "roles": {
   "cover": 8010507,
   "exterior_wall": 6839634,
   "floor": 5000801,
   "glass": 9402717,
   "ramp": 8023652,
   "riser": 5001057,
   "roof": 2303534,
   "soft_panel": 8732169,
   "stair": 8352873,
   "static_hard": 7694686
  },
  "sky": 6839374,
  "fog": 6050631,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 9209212,
  "sunIntensity": 2,
  "hemiSky": 7892578,
  "hemiGround": 1776672,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1775638,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad"
  ],
  "accent": 10766080
 },
 "shoots": {
  "roles": {
   "cover": 6513951,
   "exterior_wall": 9609107,
   "floor": 8225910,
   "glass": 13885925,
   "ramp": 11713202,
   "riser": 9147525,
   "roof": 5988437,
   "soft_panel": 6908193,
   "stair": 12305339,
   "static_hard": 11121578
  },
  "sky": 10203831,
  "fog": 9020071,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856627,
  "sunIntensity": 2.6,
  "hemiSky": 12963537,
  "hemiGround": 5790548,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2566695,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "water_tank",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad"
  ],
  "accent": 9343505
 },
 "shortdust": {
  "roles": {
   "cover": 8085548,
   "exterior_wall": 14400159,
   "floor": 9144970,
   "glass": 15791092,
   "ramp": 14271146,
   "riser": 10263451,
   "roof": 6579044,
   "soft_panel": 10385973,
   "stair": 14270378,
   "static_hard": 14729902
  },
  "sky": 12897745,
  "fog": 11450814,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15922163,
  "sunIntensity": 2.6,
  "hemiSky": 15856627,
  "hemiGround": 6381921,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 6309937,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "shorttrain": {
  "roles": {
   "cover": 14652442,
   "exterior_wall": 5790559,
   "floor": 5593173,
   "glass": 2895665,
   "ramp": 5461850,
   "riser": 5593173,
   "roof": 2632233,
   "soft_panel": 15577162,
   "stair": 5725023,
   "static_hard": 6449002
  },
  "sky": 2237477,
  "fog": 2039841,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3355700,
  "sunIntensity": 2,
  "hemiSky": 2698028,
  "hemiGround": 2303011,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 855566,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "siege": {
  "roles": {
   "cover": 8726784,
   "exterior_wall": 7885632,
   "floor": 6510154,
   "glass": 2627598,
   "ramp": 7361085,
   "riser": 6969934,
   "roof": 3156772,
   "soft_panel": 8727040,
   "stair": 7491900,
   "static_hard": 8740679
  },
  "sky": 1774350,
  "fog": 1577485,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2235674,
  "sunIntensity": 2,
  "hemiSky": 1972243,
  "hemiGround": 2959396,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 657158,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "sienna": {
  "roles": {
   "cover": 7300630,
   "exterior_wall": 10193010,
   "floor": 6773576,
   "glass": 12884863,
   "ramp": 11445394,
   "riser": 7693390,
   "roof": 4867636,
   "soft_panel": 8484374,
   "stair": 11839900,
   "static_hard": 11115145
  },
  "sky": 10188382,
  "fog": 8940375,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12366508,
  "sunIntensity": 2.6,
  "hemiSky": 10981763,
  "hemiGround": 4538165,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2630943,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0.08
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "silo": {
  "roles": {
   "cover": 8733952,
   "exterior_wall": 5857368,
   "floor": 6316641,
   "glass": 2172450,
   "ramp": 5528402,
   "riser": 7632757,
   "roof": 3816507,
   "soft_panel": 9193984,
   "stair": 5463121,
   "static_hard": 6450017
  },
  "sky": 1711131,
  "fog": 1513752,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2566183,
  "sunIntensity": 2,
  "hemiSky": 2105888,
  "hemiGround": 3750458,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 921358,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "sirocco": {
  "roles": {
   "cover": 2853020,
   "exterior_wall": 9748454,
   "floor": 8823460,
   "glass": 14676475,
   "ramp": 10603491,
   "riser": 10072245,
   "roof": 6060664,
   "soft_panel": 3386311,
   "stair": 10602211,
   "static_hard": 11127781
  },
  "sky": 9551580,
  "fog": 8039886,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15725557,
  "sunIntensity": 2.6,
  "hemiSky": 13557480,
  "hemiGround": 6189427,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2642282,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "site": {
  "roles": {
   "cover": 4146754,
   "exterior_wall": 6052956,
   "floor": 11382189,
   "glass": 2565927,
   "ramp": 5789782,
   "riser": 12763842,
   "roof": 9211020,
   "soft_panel": 4738891,
   "stair": 5723991,
   "static_hard": 6776677
  },
  "sky": 1973790,
  "fog": 1776411,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2894892,
  "sunIntensity": 2,
  "hemiSky": 2368548,
  "hemiGround": 11184810,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 723723,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668
 },
 "st_marc": {
  "roles": {
   "cover": 6966568,
   "exterior_wall": 12108225,
   "floor": 6646110,
   "glass": 14477037,
   "ramp": 12567748,
   "riser": 7566953,
   "roof": 4803652,
   "soft_panel": 8872240,
   "stair": 12567748,
   "static_hard": 12962249
  },
  "sky": 10597567,
  "fog": 9348015,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856627,
  "sunIntensity": 2.6,
  "hemiSky": 13489369,
  "hemiGround": 4671811,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4014658,
   "alpha": 0.2,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.05
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "stadium": {
  "roles": {
   "cover": 7424024,
   "exterior_wall": 6776404,
   "floor": 5855572,
   "glass": 2895657,
   "ramp": 8091749,
   "riser": 5855828,
   "roof": 3749942,
   "soft_panel": 9526042,
   "stair": 8355945,
   "static_hard": 7697760
  },
  "sky": 2237217,
  "fog": 1974302,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3224113,
  "sunIntensity": 2,
  "hemiSky": 2697768,
  "hemiGround": 3618612,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1381650,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.08
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "station": {
  "roles": {
   "cover": 7815437,
   "exterior_wall": 7558725,
   "floor": 8092784,
   "glass": 10191715,
   "ramp": 7098945,
   "riser": 9408644,
   "roof": 5131845,
   "soft_panel": 8077322,
   "stair": 7098945,
   "static_hard": 8282190
  },
  "sky": 7365716,
  "fog": 6510925,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 9801606,
  "sunIntensity": 2,
  "hemiSky": 8484713,
  "hemiGround": 4868677,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1512208,
   "alpha": 0.2,
   "scale": 1.1
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "storm": {
  "roles": {
   "cover": 3245312,
   "exterior_wall": 8217659,
   "floor": 7952181,
   "glass": 12031816,
   "ramp": 7625274,
   "riser": 8479801,
   "roof": 3745049,
   "soft_panel": 3179776,
   "stair": 7693369,
   "static_hard": 8810566
  },
  "sky": 8351301,
  "fog": 7365185,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 10327424,
  "sunIntensity": 2,
  "hemiSky": 9338974,
  "hemiGround": 2958361,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 854792,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "stronghold": {
  "roles": {
   "cover": 2447806,
   "exterior_wall": 11582154,
   "floor": 13347472,
   "glass": 12638452,
   "ramp": 12042957,
   "riser": 14206124,
   "roof": 11694950,
   "soft_panel": 4027358,
   "stair": 11976398,
   "static_hard": 12371154
  },
  "sky": 8299474,
  "fog": 6984388,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15725301,
  "sunIntensity": 2.6,
  "hemiSky": 12044251,
  "hemiGround": 12494485,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3423302,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.02
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "studio": {
  "roles": {
   "cover": 6756461,
   "exterior_wall": 5590124,
   "floor": 4932203,
   "glass": 3614022,
   "ramp": 6378872,
   "riser": 4801132,
   "roof": 2958908,
   "soft_panel": 8264327,
   "stair": 6576510,
   "static_hard": 6247799
  },
  "sky": 2760754,
  "fog": 2498092,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 3946049,
  "sunIntensity": 2,
  "hemiSky": 3287609,
  "hemiGround": 2828343,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1117972,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "subzero": {
  "roles": {
   "cover": 8978240,
   "exterior_wall": 11649224,
   "floor": 8823733,
   "glass": 4555415,
   "ramp": 12109003,
   "riser": 10466757,
   "roof": 5996948,
   "soft_panel": 10157916,
   "stair": 12108748,
   "static_hard": 12437713
  },
  "sky": 4218730,
  "fog": 3888477,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 7176584,
  "sunIntensity": 2,
  "hemiSky": 5533303,
  "hemiGround": 6388104,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2699572,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "sugarcane": {
  "roles": {
   "cover": 8868130,
   "exterior_wall": 5987676,
   "floor": 6248271,
   "glass": 4211523,
   "ramp": 5790297,
   "riser": 6182479,
   "roof": 2828583,
   "soft_panel": 11297832,
   "stair": 6119262,
   "static_hard": 6645606
  },
  "sky": 3289907,
  "fog": 2960942,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 4803146,
  "sunIntensity": 2,
  "hemiSky": 3947837,
  "hemiGround": 2236703,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1052944,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.02
  },
  "daylight": false,
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636
 },
 "survivor": {
  "roles": {
   "cover": 2368865,
   "exterior_wall": 10268638,
   "floor": 9279950,
   "glass": 15526905,
   "ramp": 10923998,
   "riser": 11057628,
   "roof": 6906550,
   "soft_panel": 2895227,
   "stair": 10925534,
   "static_hard": 11386081
  },
  "sky": 16119290,
  "fog": 14013674,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15790324,
  "sunIntensity": 2.6,
  "hemiSky": 15724534,
  "hemiGround": 9278653,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2830941,
   "alpha": 0.2,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "swamp": {
  "roles": {
   "cover": 10325549,
   "exterior_wall": 5526852,
   "floor": 9344878,
   "glass": 15464185,
   "ramp": 5066305,
   "riser": 10462846,
   "roof": 6581838,
   "soft_panel": 13022262,
   "stair": 5131841,
   "static_hard": 6250574
  },
  "sky": 11982304,
  "fog": 10273745,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15791093,
  "sunIntensity": 2.6,
  "hemiSky": 15725814,
  "hemiGround": 6448720,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1052686,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "terminal_map": {
  "roles": {
   "cover": 9131776,
   "exterior_wall": 8220245,
   "floor": 6970691,
   "glass": 6641728,
   "ramp": 9666403,
   "riser": 7036740,
   "roof": 4406060,
   "soft_panel": 11430912,
   "stair": 10061160,
   "static_hard": 9272160
  },
  "sky": 4801334,
  "fog": 4275250,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6446678,
  "sunIntensity": 2,
  "hemiSky": 5525317,
  "hemiGround": 4077869,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1907222,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "thera": {
  "roles": {
   "cover": 29168,
   "exterior_wall": 9612775,
   "floor": 11184052,
   "glass": 9263496,
   "ramp": 10008299,
   "riser": 12566469,
   "roof": 8750484,
   "soft_panel": 3052031,
   "stair": 10007019,
   "static_hard": 10598637
  },
  "sky": 6703972,
  "fog": 5915993,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 9009287,
  "sunIntensity": 2,
  "hemiSky": 7692147,
  "hemiGround": 9934239,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2705265,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0
  },
  "daylight": false,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "thrill": {
  "roles": {
   "cover": 8728832,
   "exterior_wall": 5657667,
   "floor": 8224849,
   "glass": 12569055,
   "ramp": 5196864,
   "riser": 9869666,
   "roof": 4803632,
   "soft_panel": 8728832,
   "stair": 5262399,
   "static_hard": 6315341
  },
  "sky": 9082805,
  "fog": 7898791,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15066858,
  "sunIntensity": 2.6,
  "hemiSky": 11910090,
  "hemiGround": 4474419,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1184271,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "water_tank",
   "pylon",
   "crane"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "pagoda",
   "glassbox"
  ],
  "accent": 16727406
 },
 "thunder": {
  "roles": {
   "cover": 6311476,
   "exterior_wall": 6512724,
   "floor": 14275457,
   "glass": 6972760,
   "ramp": 6644312,
   "riser": 15457688,
   "roof": 13614154,
   "soft_panel": 8086079,
   "stair": 6973277,
   "static_hard": 7170655
  },
  "sky": 5197126,
  "fog": 4670784,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 7302505,
  "sunIntensity": 2,
  "hemiSky": 6118230,
  "hemiGround": 13484934,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1447444,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "tides": {
  "roles": {
   "cover": 10776607,
   "exterior_wall": 4608595,
   "floor": 9934189,
   "glass": 14147556,
   "ramp": 4344653,
   "riser": 10921085,
   "roof": 7236686,
   "soft_panel": 13733411,
   "stair": 4345165,
   "static_hard": 5201502
  },
  "sky": 10464693,
  "fog": 9280933,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15856371,
  "sunIntensity": 2.6,
  "hemiSky": 13094353,
  "hemiGround": 6710608,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 855567,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "ziggurat",
   "obelisk",
   "spire"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "gable"
  ],
  "accent": 4165466
 },
 "tire": {
  "roles": {
   "cover": 8208904,
   "exterior_wall": 7821632,
   "floor": 12096892,
   "glass": 11373417,
   "ramp": 8281675,
   "riser": 13085842,
   "roof": 9461583,
   "soft_panel": 9128453,
   "stair": 8677199,
   "static_hard": 8610889
  },
  "sky": 8416086,
  "fog": 7430223,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 10787730,
  "sunIntensity": 2,
  "hemiSky": 9601391,
  "hemiGround": 8546389,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1774866,
   "alpha": 0.2,
   "scale": 2.3
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.08
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "torn": {
  "roles": {
   "cover": 689408,
   "exterior_wall": 7430983,
   "floor": 6970692,
   "glass": 4407076,
   "ramp": 6969667,
   "riser": 6972228,
   "roof": 3286304,
   "soft_panel": 689408,
   "stair": 7036227,
   "static_hard": 8220495
  },
  "sky": 3157535,
  "fog": 2762781,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 4144436,
  "sunIntensity": 2,
  "hemiSky": 3552553,
  "hemiGround": 2433307,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 854793,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.02
  },
  "daylight": false,
  "skyline": [
   "crane",
   "chimney"
  ],
  "facade": "banded",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 828416
 },
 "trailerpark": {
  "roles": {
   "cover": 8740096,
   "exterior_wall": 13017967,
   "floor": 6967845,
   "glass": 16698027,
   "ramp": 13810079,
   "riser": 7165985,
   "roof": 4337175,
   "soft_panel": 8740096,
   "stair": 14272170,
   "static_hard": 13743504
  },
  "sky": 14718055,
  "fog": 13861715,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15920360,
  "sunIntensity": 2.6,
  "hemiSky": 14663337,
  "hemiGround": 3879196,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3549468,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.06
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "train": {
  "roles": {
   "floor": 9278101,
   "roof": 6251880,
   "static_hard": 10922926,
   "exterior_wall": 8883343,
   "riser": 10133667,
   "stair": 9804702,
   "ramp": 9541529,
   "cover": 4482367,
   "soft_panel": 9063208,
   "glass": 11455190
  },
  "sky": 11056316,
  "fog": 10661558,
  "fogNear": 30,
  "fogFar": 160,
  "sun": 15265522,
  "sunIntensity": 2.4,
  "hemiSky": 12899036,
  "hemiGround": 5593950,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 3817282,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.1
  },
  "daylight": true,
  "look": "A Russian rail depot. Cold concrete, green rolling stock, rust, a flat overcast sky.",
  "skyline": [
   "silo",
   "crane",
   "chimney"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "gable",
   "helipad"
  ],
  "accent": 12079903,
  "curated": true
 },
 "transit": {
  "roles": {
   "cover": 8927005,
   "exterior_wall": 5396581,
   "floor": 5330012,
   "glass": 4084326,
   "ramp": 6515833,
   "riser": 5330012,
   "roof": 3026741,
   "soft_panel": 11289378,
   "stair": 6778750,
   "static_hard": 6186355
  },
  "sky": 3424073,
  "fog": 3160385,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5528418,
  "sunIntensity": 2,
  "hemiSky": 4410196,
  "hemiGround": 3026482,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1250582,
   "alpha": 0.2,
   "scale": 1.2
  },
  "surface": {
   "roughness": 0.96,
   "metalness": 0.06
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "trinity": {
  "roles": {
   "cover": 8748032,
   "exterior_wall": 6383186,
   "floor": 12167441,
   "glass": 4608317,
   "ramp": 6053710,
   "riser": 14604821,
   "roof": 7427595,
   "soft_panel": 8945664,
   "stair": 6119246,
   "static_hard": 7106652
  },
  "sky": 3554354,
  "fog": 3159341,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5198412,
  "sunIntensity": 2,
  "hemiSky": 4277821,
  "hemiGround": 6314264,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1052686,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.05
  },
  "daylight": false,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "truth": {
  "roles": {
   "cover": 8730112,
   "exterior_wall": 6900272,
   "floor": 9997132,
   "glass": 16176308,
   "ramp": 6375726,
   "riser": 11443039,
   "roof": 6184495,
   "soft_panel": 8730624,
   "stair": 6506799,
   "static_hard": 7689528
  },
  "sky": 13869685,
  "fog": 13013602,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15920874,
  "sunIntensity": 2.6,
  "hemiSky": 14337200,
  "hemiGround": 5590836,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1512206,
   "alpha": 0.2,
   "scale": 2
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "truth_cut": {
  "roles": {
   "cover": 8723712,
   "exterior_wall": 9734180,
   "floor": 8736808,
   "glass": 5126712,
   "ramp": 9210914,
   "riser": 8931877,
   "roof": 4141075,
   "soft_panel": 8723200,
   "stair": 9273632,
   "static_hard": 10786344
  },
  "sky": 3813166,
  "fog": 3353386,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5195847,
  "sunIntensity": 2,
  "hemiSky": 4405817,
  "hemiGround": 920070,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 723716,
   "alpha": 0.2,
   "scale": 1.9
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "tulip": {
  "roles": {
   "cover": 4669770,
   "exterior_wall": 4739406,
   "floor": 4606281,
   "glass": 7113643,
   "ramp": 5002577,
   "riser": 4606281,
   "roof": 2632234,
   "soft_panel": 5853277,
   "stair": 5331799,
   "static_hard": 5397592
  },
  "sky": 5794687,
  "fog": 5333104,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 9673636,
  "sunIntensity": 2.6,
  "hemiSky": 7438481,
  "hemiGround": 2105890,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 789772,
   "alpha": 0.2,
   "scale": 1.9
  },
  "surface": {
   "roughness": 0.89,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "obelisk",
   "ziggurat",
   "minaret"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "setback",
   "arcade",
   "chamfer"
  ],
  "accent": 13805111
 },
 "tundra": {
  "roles": {
   "cover": 1726826,
   "exterior_wall": 3562851,
   "floor": 8176094,
   "glass": 13555682,
   "ramp": 4352112,
   "riser": 9951980,
   "roof": 4692690,
   "soft_panel": 1661292,
   "stair": 4550774,
   "static_hard": 4090736
  },
  "sky": 9872822,
  "fog": 8754343,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15790578,
  "sunIntensity": 2.6,
  "hemiSky": 12699598,
  "hemiGround": 7712969,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 1054488,
   "alpha": 0.2,
   "scale": 1.7
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "tuscan": {
  "roles": {
   "floor": 12890772,
   "roof": 11034671,
   "static_hard": 14734006,
   "exterior_wall": 13286301,
   "riser": 13944488,
   "stair": 14207660,
   "ramp": 13878695,
   "cover": 6969902,
   "soft_panel": 11565626,
   "glass": 12639464
  },
  "sky": 11455970,
  "fog": 13812644,
  "fogNear": 42,
  "fogFar": 205,
  "sun": 16774362,
  "sunIntensity": 3.1,
  "hemiSky": 14215412,
  "hemiGround": 8286034,
  "hemiIntensity": 2.4,
  "grid": {
   "line": 7035452,
   "alpha": 0.14,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0
  },
  "daylight": true,
  "look": "A hill town in hard light. Bleached plaster, ochre, olive green shutters.",
  "skyline": [
   "campanile",
   "spire"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 11028780,
  "curated": true
 },
 "vegas": {
  "roles": {
   "cover": 8718080,
   "exterior_wall": 6967374,
   "floor": 6833494,
   "glass": 4800317,
   "ramp": 7099470,
   "riser": 6833495,
   "roof": 3154215,
   "soft_panel": 9242624,
   "stair": 7427923,
   "static_hard": 7756630
  },
  "sky": 3551536,
  "fog": 3222828,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5065033,
  "sunIntensity": 2,
  "hemiSky": 4209723,
  "hemiGround": 2497569,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1315088,
   "alpha": 0.2,
   "scale": 1.9
  },
  "surface": {
   "roughness": 0.95,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "vertigo": {
  "roles": {
   "floor": 10724776,
   "roof": 7632506,
   "static_hard": 11974844,
   "exterior_wall": 10132640,
   "riser": 11448500,
   "stair": 11053742,
   "ramp": 10790570,
   "cover": 12746783,
   "soft_panel": 13668914,
   "glass": 11063528
  },
  "sky": 8368344,
  "fog": 11125462,
  "fogNear": 40,
  "fogFar": 220,
  "sun": 16775402,
  "sunIntensity": 3,
  "hemiSky": 13624564,
  "hemiGround": 6448234,
  "hemiIntensity": 2.6,
  "grid": {
   "line": 4408650,
   "alpha": 0.18,
   "scale": 2.6
  },
  "surface": {
   "roughness": 0.85,
   "metalness": 0.12
  },
  "daylight": true,
  "look": "An unfinished skyscraper. Bare concrete, exposed steel, scaffolding, sky on every side.",
  "skyline": [
   "crane",
   "water_tank"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "terrace",
   "tower",
   "setback",
   "helipad"
  ],
  "accent": 14705706,
  "curated": true
 },
 "vessel": {
  "roles": {
   "cover": 8724224,
   "exterior_wall": 9409433,
   "floor": 8726800,
   "glass": 8949918,
   "ramp": 11382964,
   "riser": 10104589,
   "roof": 6232332,
   "soft_panel": 8724224,
   "stair": 11909308,
   "static_hard": 10790828
  },
  "sky": 6975353,
  "fog": 6317164,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 10593447,
  "sunIntensity": 2.6,
  "hemiSky": 8554382,
  "hemiGround": 5317655,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2500392,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.04
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "vineyard": {
  "roles": {
   "cover": 8008971,
   "exterior_wall": 11321037,
   "floor": 5921086,
   "glass": 15070463,
   "ramp": 11846352,
   "riser": 6775364,
   "roof": 4210989,
   "soft_panel": 9518344,
   "stair": 11846864,
   "static_hard": 12241108
  },
  "sky": 10407149,
  "fog": 8567521,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15660022,
  "sunIntensity": 2.6,
  "hemiSky": 15003381,
  "hemiGround": 3947310,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 4082779,
   "alpha": 0.2,
   "scale": 1.3
  },
  "surface": {
   "roughness": 0.91,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "campanile",
   "spire",
   "water_tank"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer",
   "barrel"
  ],
  "accent": 11028780
 },
 "vostok": {
  "roles": {
   "cover": 3769265,
   "exterior_wall": 8095371,
   "floor": 11186609,
   "glass": 10139335,
   "ramp": 9936801,
   "riser": 12567748,
   "roof": 8818835,
   "soft_panel": 5742541,
   "stair": 10462376,
   "static_hard": 9410458
  },
  "sky": 7442078,
  "fog": 6652046,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 12568265,
  "sunIntensity": 2.6,
  "hemiSky": 9873071,
  "hemiGround": 10988461,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2171684,
   "alpha": 0.2,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.9299999999999999,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "warden": {
  "roles": {
   "cover": 12682286,
   "exterior_wall": 12364446,
   "floor": 10846824,
   "glass": 14671590,
   "ramp": 13287092,
   "riser": 11834242,
   "roof": 8284492,
   "soft_panel": 14328144,
   "stair": 13483703,
   "static_hard": 13088686
  },
  "sky": 11118517,
  "fog": 9934244,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15921907,
  "sunIntensity": 2.6,
  "hemiSky": 13618899,
  "hemiGround": 7626576,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 3156260,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.01
  },
  "daylight": true,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "weapons_course": {
  "roles": {
   "cover": 11909202,
   "exterior_wall": 10987670,
   "floor": 12629147,
   "glass": 14738919,
   "ramp": 12763832,
   "riser": 13681844,
   "roof": 10986098,
   "soft_panel": 13290879,
   "stair": 13092797,
   "static_hard": 12237742
  },
  "sky": 11121333,
  "fog": 9937316,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15922163,
  "sunIntensity": 2.6,
  "hemiSky": 13620180,
  "hemiGround": 12103579,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2895143,
   "alpha": 0.2,
   "scale": 1
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0
  },
  "daylight": true,
  "skyline": [
   "silo",
   "crane"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "tower",
   "curved",
   "signboard"
  ],
  "accent": 13883217
 },
 "whistle": {
  "roles": {
   "cover": 14633985,
   "exterior_wall": 12229512,
   "floor": 9072491,
   "glass": 15200507,
   "ramp": 13086110,
   "riser": 10323072,
   "roof": 7888732,
   "soft_panel": 16738329,
   "stair": 13349796,
   "static_hard": 12822680
  },
  "sky": 10008282,
  "fog": 8496076,
  "fogNear": 26,
  "fogFar": 190,
  "sun": 15790837,
  "sunIntensity": 2.6,
  "hemiSky": 13950441,
  "hemiGround": 7364445,
  "hemiIntensity": 2.5,
  "grid": {
   "line": 2760988,
   "alpha": 0.2,
   "scale": 2.1
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.07
  },
  "daylight": true,
  "skyline": [
   "spire",
   "campanile",
   "chimney"
  ],
  "facade": "punched",
  "roofs": "pitched",
  "blocks": [
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 9067060
 },
 "workout": {
  "roles": {
   "cover": 4670782,
   "exterior_wall": 9610669,
   "floor": 5069921,
   "glass": 5400435,
   "ramp": 11977158,
   "riser": 5070177,
   "roof": 3159867,
   "soft_panel": 4736317,
   "stair": 12305608,
   "static_hard": 11319743
  },
  "sky": 4410965,
  "fog": 4015691,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 6844276,
  "sunIntensity": 2,
  "hemiSky": 5463394,
  "hemiGround": 3159608,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 2501422,
   "alpha": 0.2,
   "scale": 1.6
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.01
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "wpndepot": {
  "roles": {
   "cover": 1925,
   "exterior_wall": 7423834,
   "floor": 7094600,
   "glass": 3022371,
   "ramp": 7094868,
   "riser": 7160141,
   "roof": 3285023,
   "soft_panel": 1925,
   "stair": 7029337,
   "static_hard": 8408168
  },
  "sky": 2169116,
  "fog": 1906457,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 2893609,
  "sunIntensity": 2,
  "hemiSky": 2498338,
  "hemiGround": 2168600,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 657161,
   "alpha": 0.2,
   "scale": 2.2
  },
  "surface": {
   "roughness": 0.86,
   "metalness": 0.07
  },
  "daylight": false,
  "skyline": [
   "silo",
   "crane",
   "chimney",
   "pylon"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 13205804
 },
 "zoo": {
  "roles": {
   "cover": 486042,
   "exterior_wall": 6776144,
   "floor": 6652289,
   "glass": 5328189,
   "ramp": 6512203,
   "riser": 7968150,
   "roof": 4544599,
   "soft_panel": 296388,
   "stair": 6447435,
   "static_hard": 7631192
  },
  "sky": 3947057,
  "fog": 3486765,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 5394764,
  "sunIntensity": 2,
  "hemiSky": 4604989,
  "hemiGround": 4608851,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 1184270,
   "alpha": 0.2,
   "scale": 1.5
  },
  "surface": {
   "roughness": 0.97,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "setback",
   "tower",
   "terrace",
   "helipad"
  ],
  "accent": 5080772
 },
 "zoption": {
  "roles": {
   "cover": 1521774,
   "exterior_wall": 4674673,
   "floor": 5064551,
   "glass": 1053203,
   "ramp": 4346219,
   "riser": 5129832,
   "roof": 2498354,
   "soft_panel": 1324913,
   "stair": 4346219,
   "static_hard": 5201533
  },
  "sky": 790031,
  "fog": 724237,
  "fogNear": 20,
  "fogFar": 120,
  "sun": 1250324,
  "sunIntensity": 2,
  "hemiSky": 987409,
  "hemiGround": 1183766,
  "hemiIntensity": 2.9,
  "grid": {
   "line": 395017,
   "alpha": 0.2,
   "scale": 1.8
  },
  "surface": {
   "roughness": 0.9199999999999999,
   "metalness": 0.03
  },
  "daylight": false,
  "skyline": [
   "chimney",
   "silo"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "helipad",
   "sawtooth",
   "drum"
  ],
  "accent": 147106
 },
 "nuke_lower": {
  "roles": {
   "floor": 7238776,
   "roof": 4475212,
   "static_hard": 8620686,
   "exterior_wall": 6778224,
   "riser": 7765120,
   "stair": 8094342,
   "ramp": 7831170,
   "cover": 12097567,
   "soft_panel": 12887598,
   "glass": 9091276
  },
  "sky": 1975336,
  "fog": 2435887,
  "fogNear": 14,
  "fogFar": 85,
  "sun": 14412016,
  "sunIntensity": 1.9,
  "hemiSky": 10138820,
  "hemiGround": 2764336,
  "hemiIntensity": 3,
  "grid": {
   "line": 2764337,
   "alpha": 0.24,
   "scale": 2.4
  },
  "surface": {
   "roughness": 0.88,
   "metalness": 0.1
  },
  "daylight": false,
  "look": "Under the reactor. No daylight at all, strip lights, painted concrete, pipework.",
  "skyline": [
   "cooling_tower",
   "dome",
   "chimney"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "helipad",
   "drum"
  ],
  "accent": 14266668,
  "curated": true
 },
 "train_lower": {
  "roles": {
   "floor": 6974828,
   "roof": 4343108,
   "static_hard": 8225152,
   "exterior_wall": 6514277,
   "riser": 7501429,
   "stair": 7764601,
   "ramp": 7501429,
   "cover": 3824182,
   "soft_panel": 8013090,
   "glass": 10138812
  },
  "sky": 1777698,
  "fog": 2238249,
  "fogNear": 14,
  "fogFar": 85,
  "sun": 16765322,
  "sunIntensity": 1.8,
  "hemiSky": 9676978,
  "hemiGround": 2500906,
  "hemiIntensity": 3,
  "grid": {
   "line": 2566697,
   "alpha": 0.24,
   "scale": 2
  },
  "surface": {
   "roughness": 0.9,
   "metalness": 0.1
  },
  "daylight": false,
  "look": "The tunnels below the yard. Sodium light on wet concrete, cable trays, no sky.",
  "skyline": [
   "silo",
   "crane",
   "chimney"
  ],
  "facade": "industrial",
  "roofs": "flat",
  "blocks": [
   "sawtooth",
   "barrel",
   "gable",
   "helipad"
  ],
  "accent": 12079903,
  "curated": true
 },
 "vertigo_lower": {
  "roles": {
   "floor": 9343123,
   "roof": 6250853,
   "static_hard": 10593191,
   "exterior_wall": 8750987,
   "riser": 10066847,
   "stair": 10330019,
   "ramp": 10066847,
   "cover": 11563804,
   "soft_panel": 12420396,
   "glass": 10142940
  },
  "sky": 6260908,
  "fog": 9151672,
  "fogNear": 28,
  "fogFar": 160,
  "sun": 16052194,
  "sunIntensity": 2.5,
  "hemiSky": 12375270,
  "hemiGround": 5527130,
  "hemiIntensity": 2.7,
  "grid": {
   "line": 3816512,
   "alpha": 0.2,
   "scale": 2.6
  },
  "surface": {
   "roughness": 0.87,
   "metalness": 0.12
  },
  "daylight": true,
  "look": "The floor below the top. Same concrete, less sky, more shuttering and rebar.",
  "skyline": [
   "crane",
   "water_tank"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "terrace",
   "tower",
   "setback",
   "helipad"
  ],
  "accent": 14705706,
  "curated": true
 },
 "okujou": {
  "roles": {
   "floor": 5989746,
   "static_hard": 7831950,
   "exterior_wall": 6976641,
   "riser": 8621466,
   "stair": 8358294,
   "ramp": 7634571,
   "cover": 13144378,
   "soft_panel": 11042612,
   "roof": 3949906,
   "glass": 4644074
  },
  "sky": 1449520,
  "fog": 2371133,
  "fogNear": 30,
  "fogFar": 170,
  "sun": 12375807,
  "sunIntensity": 1.7,
  "hemiSky": 5469599,
  "hemiGround": 2370618,
  "hemiIntensity": 3.2,
  "grid": {
   "line": 2765632,
   "alpha": 0.24,
   "scale": 1.9
  },
  "surface": {
   "roughness": 0.72,
   "metalness": 0.14
  },
  "daylight": false,
  "look": "A Tokyo roof after midnight. Wet concrete, cyan glazing, magenta signage, the city glowing under it.",
  "skyline": [
   "crane",
   "water_tank",
   "pylon"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "signboard",
   "drum",
   "curved",
   "tower",
   "glassbox"
  ],
  "accent": 16727406,
  "curated": true
 },
 "atrium": {
  "roles": {
   "floor": 14080217,
   "static_hard": 15658991,
   "exterior_wall": 14869733,
   "riser": 13225165,
   "stair": 15132905,
   "ramp": 14474975,
   "cover": 12858412,
   "soft_panel": 13911610,
   "roof": 10133668,
   "glass": 10474722
  },
  "sky": 8369376,
  "fog": 13622246,
  "fogNear": 40,
  "fogFar": 220,
  "sun": 16776692,
  "sunIntensity": 3.1,
  "hemiSky": 14674678,
  "hemiGround": 10134443,
  "hemiIntensity": 3,
  "grid": {
   "line": 11186358,
   "alpha": 0.16,
   "scale": 2.6
  },
  "surface": {
   "roughness": 0.42,
   "metalness": 0.06
  },
  "daylight": true,
  "look": "A corporate campus at noon. White stone, clear glass, planting, and one red line through all of it.",
  "skyline": [
   "crane",
   "water_tank"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "glassbox",
   "terrace",
   "setback",
   "tower",
   "helipad"
  ],
  "accent": 12858412,
  "curated": true
 },
 "kasbah": {
  "roles": {
   "floor": 12755574,
   "static_hard": 11043162,
   "exterior_wall": 9859404,
   "riser": 11702118,
   "stair": 11899498,
   "ramp": 11373154,
   "cover": 7293484,
   "soft_panel": 8214324,
   "roof": 8014380,
   "glass": 4168360
  },
  "sky": 10274014,
  "fog": 13349260,
  "fogNear": 30,
  "fogFar": 170,
  "sun": 16773586,
  "sunIntensity": 2.9,
  "hemiSky": 14214383,
  "hemiGround": 8019778,
  "hemiIntensity": 2.7,
  "grid": {
   "line": 7032630,
   "alpha": 0.22,
   "scale": 1.4
  },
  "surface": {
   "roughness": 0.94,
   "metalness": 0.02
  },
  "daylight": true,
  "look": "A desert market in the afternoon. Mudbrick, timber awnings, glazed tile, dust in the light.",
  "skyline": [
   "minaret",
   "water_tank",
   "campanile"
  ],
  "facade": "punched",
  "roofs": "flat",
  "blocks": [
   "arcade",
   "chamfer",
   "gable",
   "barrel"
  ],
  "accent": 13208636,
  "curated": true
 },
 "interchange": {
  "roles": {
   "floor": 9276292,
   "static_hard": 11052187,
   "exterior_wall": 10196620,
   "riser": 11841444,
   "stair": 11578272,
   "ramp": 10854550,
   "cover": 9071176,
   "soft_panel": 9400138,
   "roof": 7031356,
   "glass": 10471119
  },
  "sky": 12175053,
  "fog": 11713987,
  "fogNear": 40,
  "fogFar": 220,
  "sun": 16774108,
  "sunIntensity": 2.3,
  "hemiSky": 12833498,
  "hemiGround": 7236194,
  "hemiIntensity": 3,
  "grid": {
   "line": 6249299,
   "alpha": 0.2,
   "scale": 2.4
  },
  "surface": {
   "roughness": 0.93,
   "metalness": 0.04
  },
  "daylight": true,
  "look": "A suburban interchange in flat afternoon light. Board-marked concrete, a rust-red canopy, enamel signage, weeds in the ballast.",
  "skyline": [
   "pylon",
   "water_tank",
   "chimney"
  ],
  "facade": "banded",
  "roofs": "flat",
  "blocks": [
   "shed",
   "sawtooth",
   "gable",
   "arcade",
   "chamfer"
  ],
  "accent": 12862510,
  "curated": true
 }
};
